// tslint:disable: max-line-length
import { ApiService } from '../../services/api_service';
import * as config from '../../wips.config.js';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { DatenauswertungFormWrapper } from './DatenauswertungFormWrapper';
import { DatenauswertungGenerisch } from './DatenauswertungGenerisch';
import { DatenauswertungJahrauswahlEinzeln } from './DatenauswertungJahrauswahlEinzeln';
import { DatenauswertungReportKonfigurationBemerkungButton } from './DatenauswertungReportKonfigurationBemerkungButton';
import datenauswertungStyle from './datenauswertung.less'
import { fn0, fn2, fn3d, formatNumber } from '../../core/formatter/formatNumber';
import formStyle from '../../core/forms/style/WForm.less'
import { getCO2Aequivalent, getCO2AequivalentGasKeys } from '../../main/functions/getCO2Aequivalent';
import { getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert, getCO2Scope3StructureAllgemein } from '../dateneingabe/functions/getCO2Scope3Structure';
import { getColorsScope3 } from './helper/getColorsScope3';
import { getDatenqualitaet } from '../../main/functions/getDatenqualitaet';
import { getEinheitenUmrechnung } from '../dateneingabe/functions/getEinheitUmrechung';
import { getEmissionsFaktor } from '../../main/functions/getEmmissionsFaktor';
import { getLastYearWithValues } from './helper/getLastYearWithValues';
import { getRoutingCO2Scope3 } from '../../helpers/getRoutingCO2Scope3';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
// import { getStyle } from './generisch/DatanauswertungGenerischStyles';
import { getUmrechungsFaktor } from '../../main/functions/getUmrechnungsFaktor';
import { i18n } from '../../i18n/i18n';
import { i18n2 } from '../../i18n/i18n_core';
import { IDs } from '../../helpers/IDs';
import { isVeranstaltung } from '../../helpers/getVeranstaltungen';
import { KennzahlenInfo } from './elements/KennzahlenInfo';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { renderFaktorQuelle } from './helper/renderFaktorQuelle';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { StandortAuswahl } from './elements/StandortAuswahl';
import { StructureService } from '../../services/structure_service';
import style from './datenauswertung.less'
import { transformDatenqualitaet } from './helper/transformDatenqualitaet';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WActionButton } from '../../core/elements/WActionButton';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WpdfText } from './pdf/WpdfText.';
import { WpdfView } from './pdf/WpdfView';

interface DatenauswertungCO2FussabdruckDetailsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    standortTid: number;
    standortName: string;
    routing: any;
    jahr?: number;
    chartOnly?: boolean;
    contentOnly?: boolean;
    hideChartTitle?: boolean;
    diagramStyle?: React.CSSProperties;
    parentElement?: string;
    setJSXdirect?: (content: JSX.Element) => void;
    callbackPages?: (pageNumber: number, totalPages: number) => void;
    onChartSelectChange?: (co2Diagram: any) => void;
    getChartSelector?: (element: JSX.Element) => void;
    autoOpen?: boolean;
    pdfLayoutless?: boolean;
    id?: string;
    onStandortChange?: (standort: number) => void;
}

interface DatenauswertungCO2FussabdruckDetailsState {
    pdfString?: string;
    jahr: number;
    jahrMin: number;
    jahrMax: number;
    zuschlag: number;
    renderButton: JSX.Element;
    chartKey: string;
    chartKeyT2: string;
    values: any;
    openKategorien: any;
    openSubscopes: any;
    showQuellen: boolean;
    columnsSortIndex: number;
}

export class DatenauswertungCO2FussabdruckDetails extends
    React.Component<DatenauswertungCO2FussabdruckDetailsProps, DatenauswertungCO2FussabdruckDetailsState> {

    constructor(props: any) {
        super(props);
        const data: any = props.data || {};
        const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
        const jahrMax: number = getLastYearWithValues(this.props.data, this.props.standortTid) || new Date().getFullYear();
        let jahrMin: number = (data.first_year > 2009 && data.first_year < 2015) ? data.first_year : 2015;
        jahrMin = (startjahr > jahrMin) ? startjahr : jahrMin;
        // Sicherheitszuschlag suchen
        const jahrContext = this.contextService.get('jahr_cockpit');
        const jahrUse = props.jahr || (jahrContext && jahrContext <= jahrMax ? jahrContext : jahrMax);
        const zuschlagItem = this.getZuschlagItem(jahrUse);
        this.state = {
            jahrMin,
            jahrMax,
            jahr: jahrUse,
            renderButton: undefined,
            zuschlag: zuschlagItem ? zuschlagItem.zuschlag : 0,
            chartKey: null,
            chartKeyT2: null,
            values: null,
            openKategorien: {},
            openSubscopes: {},
            showQuellen: false,
            columnsSortIndex: 0
        };
        this.zuschlagKey = `${this.props.standortTid}_${jahrUse}`;
        this.renderZuschlagEingabe = this.renderZuschlagEingabe.bind(this);
        this.renderDisclaimer = this.renderDisclaimer.bind(this);
        this.renderQuellen = this.renderQuellen.bind(this);
        this.setChartSelect = this.setChartSelect.bind(this);
        this.setChartSelect2 = this.setChartSelect2.bind(this);
        // this.showKennzahlenInfo = !!this.devFeaturesMap.N131_KENNZAHLEN_BERECHNUNG && (this.apiService.isAdmin() || this.apiService.isBerater());
        this.showKennzahlenInfo = true;
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private zuschlagHandle: number;
    private zuschlagKey: string;
    private zuschlagSaveItem: any;
    private chartColors = ['#c5ceb9', '#ddd', '#728a49'];
    private colorVorjahreswerte = '#7f7f7f';
    private columnsSortOptions = [
        {
            name: i18n('Alphabetisch', 'sys'), sort: (a: any, b: any) =>
                ((a || {}).kategorie || '').toString().localeCompare(((b || {}).kategorie || '').toString())
                || (a.group - b.group)
                || ((a || {}).name || '').toString().localeCompare(((b || {}).name || '').toString())
        },
        {
            name: `${i18n('CO₂-Menge', 'sys')} (${i18n('aufsteigend', 'sys')})`, sort: (a: any, b: any) =>
                (a.sum - b.sum)
                || ((a || {}).kategorie || '').toString().localeCompare(((b || {}).kategorie || '').toString())
                || (a.group - b.group) || (a.value - b.value)
        },
        {
            name: `${i18n('CO₂-Menge', 'sys')} (${i18n('absteigend', 'sys')})`, sort: (a: any, b: any) =>
                (b.sum - a.sum)
                || ((a || {}).kategorie || '').toString().localeCompare(((b || {}).kategorie || '').toString())
                || (a.group - b.group) || (b.value - a.value)
        }
    ];
    private dataSort: any = {};
    private devFeaturesMap: any = config.devFeaturesMap || {};
    private modul: string;
    private quellen = [] as string[];
    private showKennzahlenInfo: boolean;

    componentDidMount(): void {
        const preset = this.contextService.get('co2_detail_chartKey');
        this.modul = (this.props.data || {}).MODUL_SELECTED || null;
        this.setChartSelect(preset);
    }

    componentDidUpdate(prevProps: Readonly<DatenauswertungCO2FussabdruckDetailsProps>, prevState: Readonly<DatenauswertungCO2FussabdruckDetailsState>, snapshot?: any): void {
        if (prevState.jahr !== this.state.jahr) {
            this.setState({ openKategorien: {}, openSubscopes: {} }, () => this.setChartSelect(this.state.chartKey));
        } else if (prevState.columnsSortIndex !== this.state.columnsSortIndex) {
            const openKategorien: any = this.state.openKategorien || {};
            const openSubscopes: any = this.state.openSubscopes || {};
            this.setState(
                { openKategorien: {}, openSubscopes: {} },
                () => this.setState({ openKategorien, openSubscopes }, () => this.setChartSelect(this.state.chartKey))
            );
        }
    }

    getValues(chartKey?: string, presetJahr?: number): any {
        const data: any = this.props.data || {};
        presetJahr = presetJahr || this.state.jahr;
        const legendFormat = '[key] [name] [[value] t CO₂ Äq / [percentage] %]';
        const labelFormat = '[key]';
        let rows: any[] = [];
        let custom_row_classes: any[] = [];
        let row_groups: any[] = [];
        this.quellen = [];
        const temp_row_groups: any[] = [];
        const kennzahlen: any = (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[this.props.standortTid]
            || data[IDs.KENNZIFFERN_BERECHNET] || {};

        // console.log('kennzahlen', kennzahlen[presetJahr]);

        const kz = kennzahlen[presetJahr] || {};
        const setRowGroups = (data: any[] = [], name: string = null): void => {
            row_groups.push({ name, pos: 0, len: data.length });
            row_groups = row_groups.concat(data.map((item: any, index: number) => {
                return { name, pos: index + 1, len: data.length };
            }));
        };
        const setTempRowGroups = (data: any[] = [], name: string = null, index: number = 0): void => {
            if (!Array.isArray(temp_row_groups[index])) {
                temp_row_groups[index] = [];
            }
            temp_row_groups[index].push({ name, pos: 0, len: data.length });
            temp_row_groups[index] = temp_row_groups[index].concat(data.map((item: any, index: number) => {
                return { name, pos: index + 1, len: data.length };
            }));
        };

        const sum: any = {};
        // console.log('CO2_' + presetJahr, kz);
        const row_type_scope = [
            'row_field_green_scope', 'row_field_green_scope_left', 'row_field_green_scope', 'row_field_green_scope',
            'row_field_green_scope', 'row_field_green_scope', 'row_field_green_scope'
        ];
        const row_type_scope_oos = [
            'row_field_oos_scope', 'row_field_oos_scope_left', 'row_field_oos_scope_visible', 'row_field_oos_scope',
            'row_field_oos_scope', 'row_field_oos_scope', 'row_field_oos_scope'
        ];
        const row_type_heading = [
            'row_field_green_heading', 'row_field_green_heading_left', 'row_field_green_heading_plain', 'row_field_green_heading_right',
            'row_field_green_heading_right', 'row_field_green_heading_right', 'row_field_green_heading_right'
        ];
        const row_type_heading_kategorie = [
            'row_field_center', 'row_field_kategorie_scope_left', 'row_field_kategorie_scope_plain', 'row_field_kategorie_scope_right',
            'row_field_kategorie_scope_right', 'row_field_kategorie_scope_left', 'row_field_kategorie_scope_left'
        ];
        const row_type_heading_oos = [
            'row_field_oos_heading', 'row_field_oos_heading_left', 'row_field_oos_heading_plain', 'row_field_oos_heading_right',
            'row_field_oos_heading_right', 'row_field_oos_heading_right', 'row_field_oos_heading_right'
        ];
        const row_type_heading_strom = [
            'row_field_green_heading', 'row_field_green_heading_left', 'row_field_green_heading_plain_visible',
            'row_field_green_heading_right', 'row_field_green_heading_right', 'row_field_green_heading_right',
            'row_field_green_heading_right'
        ];
        const row_type_item = [
            'row_field_center', 'row_field_left', 'row_field_right', 'row_field_right', 'row_field_right', 'row_field_right',
            'row_field_center'
        ];
        const row_type_item_info = [
            'row_field_center', 'row_field_italic_grey_left', 'row_field_italic_grey_right', 'row_field_italic_grey_right',
            'row_field_italic_grey_right', 'row_field_italic_grey_right', 'row_field_italic_grey'
        ];
        const row_type_item_hidden = [
            'row_field_hidden', 'row_field_hidden', 'row_field_hidden', 'row_field_hidden', 'row_field_hidden', 'row_field_hidden',
            'row_field_hidden'
        ];
        const row_type_item_s3 = [
            'row_field_green_heading', 'row_field_left', 'row_field_right', 'row_field_right', 'row_field_right', 'row_field_right',
            'row_field_right'
        ];
        const row_type_sum = [
            'row_field_white', 'row_field_white', 'row_field_white', 'row_field_green_sum_right', 'row_field_green_sum_right',
            'row_field_white', 'row_field_white'
        ];
        const row_type_sum_lb = [
            'row_field_white', 'row_field_white_lb', 'row_field_white', 'row_field_white_sum_right_lb', 'row_field_white',
            'row_field_white', 'row_field_white'
        ];
        const row_type_sum_oos = [
            'row_field_white', 'row_field_white', 'row_field_white_right', 'row_field_oos_sum_right', 'row_field_oos_sum_right',
            'row_field_white', 'row_field_white'
        ];
        const row_type_sum_table = [
            'row_field_sum', 'row_field_sum', 'row_field_sum', 'row_field_sum_right_highlight', 'row_field_sum_right_highlight',
            'row_field_sum', 'row_field_sum'
        ];
        const row_type_sum_table_oos = [
            'row_field_sum', 'row_field_sum', 'row_field_sum', 'row_field_oos_sum_right_highlight', 'row_field_oos_sum_right_highlight',
            'row_field_sum', 'row_field_sum'
        ];
        const row_type_empty = [
            'row_field_white', 'row_field_empty', 'row_field_white', 'row_field_white', 'row_field_white', 'row_field_white',
            'row_field_white'
        ];
        const row_type_total = [
            'row_field_green_total', 'row_field_green_total_left', 'row_field_green_total_right', 'row_field_green_total_right',
            'row_field_green_total_right', 'row_field_green_total_right', 'row_field_green_total_right'
        ];
        const row_type_total_help = [
            'row_field_green_total', 'row_field_green_total_left', 'row_field_green_total_right_help', 'row_field_green_total_right',
            'row_field_green_total_right', 'row_field_green_total_right', 'row_field_green_total_right'
        ];
        const row_type_total_help_0mt = [
            'row_field_green_total_0mt', 'row_field_green_total_left_0mt', 'row_field_green_total_right_help_0mt', 'row_field_green_total_right_0mt',
            'row_field_green_total_right_0mt', 'row_field_green_total_right_0mt', 'row_field_green_total_right_0mt'
        ];
        const row_type_total_lb = [
            'row_field_white_total', 'row_field_white_total_left_lb', 'row_field_white_total_right', 'row_field_white_total_right_lb',
            'row_field_white_total_right', 'row_field_white_total_right', 'row_field_white_total_right'
        ];
        const row_type_total2 = [
            'row_field_green_sum', 'row_field_green_sum_left', 'row_field_green_sum_right', 'row_field_green_sum_right',
            'row_field_green_sum_right', 'row_field_green_sum_right', 'row_field_green_sum_right'
        ];
        const row_type_total2_help = [
            'row_field_green_sum', 'row_field_green_sum_left', 'row_field_green_sum_right_help', 'row_field_green_sum_right',
            'row_field_green_sum_right', 'row_field_green_sum_right', 'row_field_green_sum_right'
        ];
        const keys1_1 = [
            'bio_brennholz', 'bio_brennholz_rm', 'bio_hackschnitzel', 'bio_hackschnitzel_srm', 'bio_holzpellets', 'bio_holzpellets_kg',
            'erdgas', 'erdgas_m3', 'fluessiggas', 'fluessiggas_liter', 'fluessiggas_kg', 'hel', 'hel_liter', 'andere', 'braunkohle_kg', 'braunkohle',
            'steinkohle_kg', 'steinkohle', 'biogas_kg', 'biogas_m3', 'biogas', 'angemietet_waerme', 'angemietet_ww', 'eigene_waerme', 'eigene_ww', 'abzug_waerme'
        ];
        const keys1_2 = [
            'benzin', 'diesel', 'lpg', 'wasserstoff_kwh', 'wasserstoff_kg', 'erdgas_kraftstoff', 'erdgas_kg', 'erdgas_cng_kg',
            'erdgas_lng_kg', 'biodiesel', 'bioethanol', 'abzug_kraftstoff', 'angemietete_fahrzeuge'
        ];
        const keys1_3 = [...getCO2AequivalentGasKeys(this.props.data), 'abzug_gase'];
        const keys2_1 = ['strom', 'ladestrom', 'strom_waerme', 'angemietet_strom', 'eigene_strom', 'abzug_strom', 'angemietete_fahrzeuge_strom'];
        const keys2_2 = ['fernwaerme', 'fernwaerme_mwh', 'fernkaelte', 'abzug_fernwaerme', 'angemietet_kaelte', 'eigene_kaelte'];
        // Zeilen 1.1
        const classes1_1: any[] = [];
        const rows1_1: any[] = [];
        sum['1.1'] = 0;
        let dataSort: any[] = [];
        const co2_total = kz.co2_fussabdruck_total;
        const co2_oos = kz.co2_fussabdruck_scope_oos;

        // console.log('CO2 KZ', presetJahr, kz);
        keys1_1.forEach((key: string) => {
            let key_use = key;
            let einheit_use = undefined;
            let faktor_mengenumrechnung = 1;
            let name_use = null;
            if (key_use === 'hel_liter') {
                key_use = 'hel';
                einheit_use = 'Liter';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'heizoel_leicht');
            }
            if (key_use === 'bio_brennholz_rm') {
                einheit_use = 'Rm';
                key_use = 'bio_brennholz';
                const faktor_kg = getEinheitenUmrechnung('rm', 'bio_brennholz').factor;
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'brennholz') * faktor_kg;
            }
            if (key_use === 'fluessiggas_kg') {
                einheit_use = 'kg';
                key_use = 'fluessiggas';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'fluessiggas_kg');
            }
            if (key_use === 'fluessiggas_liter') {
                einheit_use = 'Liter';
                key_use = 'fluessiggas';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'fluessiggas_l');
            }
            // if (key_use === 'erdgas_kg') {
            //     key_use = 'erdgas';
            //     einheit_use = 'kg';
            //     faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'erdgas_kg');
            // }
            if (key_use === 'erdgas_m3') {
                key_use = 'erdgas';
                einheit_use = 'm3';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'erdgas_m3');
            }
            if (key_use === 'bio_hackschnitzel_srm') {
                einheit_use = 'Srm';
                key_use = 'bio_hackschnitzel';
                const faktor_kg = getEinheitenUmrechnung('srm', 'bio_hackschnitzel').factor;
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'hackschnitzel') * faktor_kg;
            }
            if (key_use === 'bio_holzpellets_kg') {
                einheit_use = 'Kg';
                key_use = 'bio_holzpellets';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'holzpellets');
            }
            if (key_use === 'andere') {
                einheit_use = 'kWh';
                name_use = 'Sonstige Wärmeträger';
                // faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'holzpellets');
            }
            if (key_use === 'fernkaelte') {
                einheit_use = 'kWh';
                name_use = 'Fernkälte';
                // faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'holzpellets');
            }
            if (key_use === 'steinkohle_kg') {
                einheit_use = 'kg';
                key_use = 'steinkohle';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'steinkohle');
                // console.log('Kohle', key_use, faktor_mengenumrechnung);
            }
            if (key_use === 'braunkohle_kg') {
                einheit_use = 'kg';
                key_use = 'braunkohle';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'braunkohle');
                // console.log('Kohle', key_use, faktor_mengenumrechnung);
            }
            if (key_use === 'biogas_kg') {
                einheit_use = 'kg';
                key_use = 'biogas';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'biogas_kg');
                // console.log('Kohle', key_use, faktor_mengenumrechnung);
            }
            if (key_use === 'biogas_m3') {
                einheit_use = 'm3';
                key_use = 'biogas';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'biogas_m3');
                // console.log('Kohle', key_use, faktor_mengenumrechnung);
            }
            const item = getCO2Aequivalent(this.props.data, presetJahr, key_use, false);

            const name = i18n(name_use || item.name, 'sys');
            const key_menge = `co2_fussabdruck_${key}_menge`;
            const key_wert = `co2_fussabdruck_${key}_wert`;
            const key_anteil = `co2_fussabdruck_${key}_anteil`;
            const key_faktor = `faktor_co2_${key}`;
            const key_datenqualitaet = `co2_fussabdruck_${key === 'biogas' ? 'biogas_kwh' : key}_datenqualitaet`;
            const factor_show = (kz[key_faktor] || kz[key_faktor] === 0) ? kz[key_faktor] : item.wert;

            /*
            if (key === 'andere') {
                console.log('auswertung...', this.props.standortTid, this.props.standortName, key, key_use, key_datenqualitaet);
            }
            */

            if (!kz[key_anteil] && kz[key_anteil] !== 0) {
                kz[key_anteil] = 0;
            }
            if (key_use === 'andere') {
                // console.log('Andere', key_wert, key_anteil);
            }
            if (key_use === 'abzug_waerme' && kz[key_wert]) {
                const row = [
                    '', `${i18n('Abzug aus', 'sys')} Scope 3.13.1`, '', fn2(kz[key_wert]), `${fn2(kz[key_anteil])} %`,
                    '', transformDatenqualitaet(kz[key_datenqualitaet])
                ];
                classes1_1.push(row_type_item);
                rows1_1.push(row);
                sum['1.1'] += kz[key_wert];
                dataSort.push({ name: `${i18n('Abzug aus', 'sys')} Scope 3.13.1`, value: kz[key_wert], group: 2, _row: row });
            } else if ((key_use === 'angemietet_waerme' || key_use === 'angemietet_ww') && kz[key_wert]) {
                const name_w = i18n(key_use === 'angemietet_waerme' ? 'Wärme' : 'Warmwasser', 'sys');
                const key_quelle_raum = key_use === 'angemietet_waerme' ? 'faktor_quelle_rw_co2_raum' : 'faktor_quelle_ww_co2_raum';
                const faktor_str = renderFaktorQuelle(formatNumber(kz[key_wert] / kz[key_menge] * 1000000, 0), 'gCO₂Äq/kWh', kz[key_quelle_raum], this.quellen);
                const key_dq = `co2_fussabdruck_${key}_arr_datenqualitaet`;
                kz[key_datenqualitaet] = getDatenqualitaet(kz[key_dq]);
                // console.log('Angemietet Waerme', key_datenqualitaet, key_dq, kz[key_datenqualitaet], kz[key_dq]);

                // WKETOOL-167: Transparente Berechnung
                const keyVerbrauch = key.replace('angemietet_', 's2_raeume_');
                const keyCo2 = `${keyVerbrauch}_co2`;
                const field = 'menge';
                const einheit = 'kWh';
                const textVerbrauch = `${fn0(kz[key_menge])} ${einheit}`;
                const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, field);
                const textEmission = fn2(kz[key_wert]);
                const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, field);
                const row = [
                    '', `${name_w} (${i18n('Angemietete Räumlichkeiten', 'sys')})`, verbrauch, emission, `${fn2(kz[key_anteil])} %`,
                    faktor_str, transformDatenqualitaet(kz[key_datenqualitaet])
                ];

                classes1_1.push(row_type_item);
                rows1_1.push(row);
                sum['1.1'] += kz[key_wert];
                dataSort.push({ name: name_w, value: kz[key_wert], group: 1, _row: row });
            } else if ((key_use === 'eigene_waerme' || key_use === 'eigene_ww') && kz[key_wert]) {
                const name_w = i18n(key_use === 'eigene_waerme' ? 'Wärme' : 'Warmwasser', 'sys');

                // WKETOOL-167: Transparente Berechnung
                const keyVerbrauch = key.replace('eigene_', 's2_raeume_');
                const keyCo2 = `${keyVerbrauch}_co2`;
                const field = 'menge';
                const einheit = 'kWh';
                const textVerbrauch = `${fn0(kz[key_menge])} ${einheit}`;
                const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, field);
                const textEmission = fn2(kz[key_wert]);
                const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, field);
                const row = [
                    '', `${name_w} (${i18n('Eigene Räumlichkeiten', 'sys')})`, '', emission, `${fn2(kz[key_anteil])} %`,
                    '', transformDatenqualitaet(kz[key_datenqualitaet])
                ];

                classes1_1.push(row_type_item);
                rows1_1.push(row);
                sum['1.1'] += kz[key_wert];
                dataSort.push({ name: name_w, value: kz[key_wert], group: 1, _row: row });
            } else if (kz[key_menge]) {
                const kennKey = `waerme_${key_use}_${einheit_use || 'kwh'}`.toLowerCase();
                const renderInfoCo2: JSX.Element | string = this.showKennzahlenInfo
                    ? <KennzahlenInfo
                        data={this.props.data}
                        data-text={fn2(kz[key_wert])}
                        einheit={einheit_use || 'kWh'}
                        id={key_wert}
                        key={key_wert}
                        keyValue={`${kennKey}_co2`}
                        jahr={presetJahr}
                        standort={this.props.standortTid || 'ALL'}
                    />
                    : fn2(kz[key_wert]);
                const renderInfoVerbrauch: JSX.Element | string = this.showKennzahlenInfo
                    ? <KennzahlenInfo
                        data={this.props.data}
                        data-text={`${fn0(kz[key_menge])} ${einheit_use || item.einheit}`}
                        einheit={einheit_use || 'kWh'}
                        id={key_menge}
                        key={key_menge}
                        keyValue={`${kennKey}_verbrauch`}
                        jahr={presetJahr}
                        standort={this.props.standortTid || 'ALL'}
                    />
                    : `${fn0(kz[key_menge])} ${einheit_use || item.einheit}`;
                const row = [
                    // '', name, `${fn0(kz[key_menge])} ${einheit_use || item.einheit}`, fn2(kz[key_wert]), `${fn2(kz[key_anteil])} %`,
                    '', name, renderInfoVerbrauch, renderInfoCo2, `${fn2(kz[key_anteil])} %`,
                    renderFaktorQuelle(this.formatFaktorByName(name, (factor_show * faktor_mengenumrechnung) * 1000000), 'gCO₂Äq/' + (einheit_use || item.einheit), item.quelle, this.quellen),
                    transformDatenqualitaet(kz[key_datenqualitaet])
                ];
                classes1_1.push(row_type_item);
                rows1_1.push(row);
                sum['1.1'] += kz[key_wert];
                dataSort.push({ name, value: kz[key_wert], group: 1, _row: row });
            }
            this.sortRows(dataSort, rows1_1);
        });
        // Zeilen 1.2
        const classes1_2: any[] = [];
        const rows1_2: any[] = [];
        sum['1.2'] = 0;
        dataSort = [];
        keys1_2.forEach((key: string) => {
            let key_use = key;
            let name_use = null;
            let faktor_use = null;
            let einheit_use = undefined;
            let faktor_mengenumrechnung = 1;
            let xtra_quellen_row = false;
            const key_faktor_map = `co2_fussabdruck_${key}_faktor_map`;
            const key_datenqualitaet = `co2_fussabdruck_${key}_datenqualitaet`;
            if (key_use === 'wasserstoff_kg') {
                key_use = 'wasserstoff';
                einheit_use = 'kg';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'wasserstoff');
            } else if (key_use === 'benzin') {
                einheit_use = 'Liter';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'ottokraftstoffe');
            } else if (key_use === 'diesel') {
                einheit_use = 'Liter';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'dieselkraftstoffe');
            } else if (key_use === 'erdgas_cng_kg') {
                einheit_use = 'kg';
                name_use = i18n('Erdgas CNG', 'sys');
                key_use = 'erdgas';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'erdgas_cng_kg');
            } else if (key_use === 'erdgas_lng_kg') {
                einheit_use = 'kg';
                name_use = i18n('Erdgas LNG', 'sys');
                key_use = 'erdgas';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'erdgas_lng_kg');
            } else if (key_use === 'lpg') {
                einheit_use = 'Liter';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'fluessiggas_l');
                // console.log('Faktor Mengenumrechnung: ', faktor_mengenumrechnung);
            } else if (key_use === 'bioethanol') {
                einheit_use = 'Liter';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'bioethanol');
            } else if (key_use === 'biodiesel') {
                einheit_use = 'Liter';
                faktor_mengenumrechnung = getUmrechungsFaktor(this.props.data, '', presetJahr, 'biodiesel');
            } else if (key_use === 'abzug_kraftstoff') {
                name_use = `${i18n('Abzug aus', 'sys')} Scope 3.13.2`;
            } else if (key_use === 'angemietete_fahrzeuge') {
                name_use = i18n('Angemietete Fahrzeuge', 'sys');
                einheit_use = 'km';
                faktor_use = 'gemischt';
                // console.log('Angemietete Fzg:', kz[key_faktor_map]);
                if (kz[key_faktor_map]) {
                    const faktor_map_fzg = kz[key_faktor_map];
                    const arr_names = Object.keys(faktor_map_fzg).map((k: string) => {
                        return faktor_map_fzg[k]['showname'];
                    });
                    name_use += '\n' + arr_names.join('\n');
                    xtra_quellen_row = true;
                }
                const key_dq = `co2_fussabdruck_${key}_arr_datenqualitaet`;
                kz[key_datenqualitaet] = getDatenqualitaet(kz[key_dq]);
            }

            const item = getCO2Aequivalent(this.props.data, presetJahr, key_use, false);
            const name = name_use || item.name;
            const key_menge = `co2_fussabdruck_${key}_menge`;
            const key_wert = `co2_fussabdruck_${key}_wert`;
            const key_anteil = `co2_fussabdruck_${key}_anteil`;
            if (!kz[key_anteil] && kz[key_anteil] !== 0) {
                kz[key_anteil] = 0;
            }
            // console.log('FAKTOR', name, item.wert , faktor_mengenumrechnung);
            if (key_use === 'abzug_kraftstoff' && kz[key_wert]) {
                const row = [
                    '', name, '', fn2(kz[key_wert]), `${fn2(kz[key_anteil])} %`,
                    '', transformDatenqualitaet(kz[key_datenqualitaet])
                ];
                classes1_2.push(row_type_item);
                rows1_2.push(row);
                sum['1.2'] += kz[key_wert];
                dataSort.push({ name, value: kz[key_wert], group: 2, _row: row });
            } else if (kz[key_menge]) {
                // const faktor_str = faktor_use || formatNumber((item.wert * faktor_mengenumrechnung) * 1000000, 0) + ' gCO₂/' + (einheit_use || item.einheit);
                const faktor_str = renderFaktorQuelle(faktor_use || formatNumber((item.wert * faktor_mengenumrechnung) * 1000000, 0), ' gCO₂Äq/' + (einheit_use || item.einheit), item.quelle, this.quellen, kz[key_faktor_map], xtra_quellen_row);

                // WKETOOL-167: Transparente Berechnung
                const einheit = einheit_use || item.einheit;
                let keyVerbrauch, keyCo2, field;
                if (key === 'erdgas_cng_kg' || key === 'erdgas_lng_kg') {
                    keyVerbrauch = key;
                    keyCo2 = key.replace('_kg', '_co2');
                    field = 'verbrauch';
                } else if (key === 'angemietete_fahrzeuge') {
                    keyVerbrauch = 'angemietete_fahrzeuge';
                    keyCo2 = 'angemietete_fahrzeuge_co2';
                    field = 'entfernung';
                } else {
                    keyVerbrauch = `${key_use}_${(einheit || '').toLowerCase()}`;
                    keyCo2 = `${key_use}_co2`;
                    field = 'verbrauch';
                }
                const textVerbrauch = `${fn0(kz[key_menge])} ${einheit}`;
                const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, field);
                const textEmission = fn2(kz[key_wert]);
                const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, field);
                const row = [
                    '', name, verbrauch, emission, `${fn2(kz[key_anteil])} %`,
                    faktor_str, transformDatenqualitaet(kz[key_datenqualitaet])
                ];

                classes1_2.push(row_type_item);
                rows1_2.push(row);
                sum['1.2'] += kz[key_wert];
                dataSort.push({ name, value: kz[key_wert], group: 1, _row: row });
            }
            this.sortRows(dataSort, rows1_2);
        });
        // Zeilen 1.3
        const classes1_3: any[] = [];
        const rows1_3: any[] = [];
        sum['1.3'] = 0;
        dataSort = [];
        keys1_3.forEach((key: string) => {
            const item = getCO2Aequivalent(this.props.data, presetJahr, key, true);
            const name = item.name;
            const key_menge = `co2_fussabdruck_${key}_menge`;
            const key_wert = `co2_fussabdruck_${key}_wert`;
            const key_anteil = `co2_fussabdruck_${key}_anteil`;
            const key_datenqualitaet = `co2_fussabdruck_${key}_datenqualitaet`;
            if (!kz[key_anteil] && kz[key_anteil] !== 0) {
                kz[key_anteil] = 0;
            }
            if (key === 'abzug_gase' && kz[key_wert]) {
                const row = [
                    '', `${i18n('Abzug aus', 'sys')} Scope 3.13.1`, '', fn2(kz[key_wert]), `${fn2(kz[key_anteil])} %`,
                    '', transformDatenqualitaet(kz[key_datenqualitaet])
                ];
                classes1_3.push(row_type_item);
                rows1_3.push(row);
                sum['1.3'] += kz[key_wert];
                dataSort.push({ name: `${i18n('Abzug aus', 'sys')} Scope 3.13.1`, value: kz[key_wert], group: 2, _row: row });
            } else if (kz[key_menge]) {
                const keyVerbrauch: string = (key || '').toString().toLowerCase();
                const textVerbrauch = `${fn0(kz[key_menge])} kg`;
                const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, 'menge');
                const keyCo2: string = `${keyVerbrauch}_co2`;
                const textEmission = fn2(kz[key_wert]);
                const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, 'menge');
                const row = [
                    '', name, verbrauch/*`${fn0(kz[key_menge])} kg`*/, emission/*fn2(kz[key_wert])*/, `${fn2(kz[key_anteil])} %`,
                    renderFaktorQuelle(formatNumber(item.wert, 0), 'kgCO₂Äq/kg', item.quelle, this.quellen),
                    transformDatenqualitaet(kz[key_datenqualitaet])
                ];
                classes1_3.push(row_type_item);
                rows1_3.push(row);
                sum['1.3'] += kz[key_wert];
                dataSort.push({ name, value: kz[key_wert], group: 1, _row: row });
            }
            this.sortRows(dataSort, rows1_3);
        });
        // Zeilen 2.1
        const classes2_1: any[] = [];
        let rows2_1: any[] = [];
        sum['2.1'] = 0;
        dataSort = [];
        let menge_strom_total = 0;
        let co2_storm_total = 0;
        let anteil_strom_total = 0;
        let einheit_strom_total = null;
        // let row_strom: any = null;
        let row_2: any = null;
        let hasAngemietet: boolean = false;
        const faktor_strom_co2 = getEmissionsFaktor(this.props.data, '', presetJahr, 'strom_mix');
        keys2_1.forEach((key: string) => {
            const aq = getCO2Aequivalent(this.props.data, presetJahr, key === 'strom_waerme' ? 'strom' : key, false);
            let isSortable: boolean = false;
            let name = aq.name;
            const key_datenqualitaet = `co2_fussabdruck_${key}_datenqualitaet`;
            if (key === 'abzug_strom') {
                name = `${i18n('Abzug aus', 'sys')} Scope 3.13.1`;
            } else if (key === 'angemietet_strom') {
                name = i18n('Angemietete Räumlichkeiten', 'sys');
                const key_dq = `co2_fussabdruck_${key}_arr_datenqualitaet`;
                kz[key_datenqualitaet] = getDatenqualitaet(kz[key_dq]);
                // console.log('Angemietet', key_datenqualitaet, key_dq, kz[key_datenqualitaet], kz[key_dq]);
            } else if (key === 'eigene_strom') {
                name = i18n('Eigene Räumlichkeiten', 'sys');
            } else if (key === 'strom_waerme') {
                name = `${i18n('Heizzstrom', 'sys')} (${i18n('z.B. Wärmepumpe', 'sys')})`;
            } else if (key === 'ladestrom') {
                name = i18n('Ladestrom E-Fahrzeug/e', 'sys');
            } else if (key === 'angemietete_fahrzeuge_strom') {
                name = `${i18n('Angemietete Fahrzeuge', 'sys')} (${i18n('Strom', 'sys')})`;
                // einheit_use = 'km';
                // faktor_use = 'gemischt';
            }
            if (key !== 'strom' && key !== 'abzug_strom' && key !== 'angemietet_strom' && key !== 'eigene_strom' && key !== 'angemietete_fahrzeuge_strom') {
                // name = '  >  davon ' + name;
                isSortable = true;
            }

            const key_menge = `co2_fussabdruck_${key}_menge`;
            const key_wert = `co2_fussabdruck_${key}_wert`;
            // const key_faktor = `faktor_${key}_co2`;
            let key_faktor = `faktor_strom_co2_calc`;
            if (key === 'strom_waerme' && (kz['faktor_co2_strom'] || kz['faktor_co2_strom'] === 0)) {
                key_faktor = 'faktor_co2_strom';
            }
            const key_quelle = `faktor_quelle_strom_co2`;
            const key_quelle_fzg = `faktor_quelle_strom_co2_fzg`;
            const key_quelle_raum = `faktor_quelle_strom_co2_raum`;
            const key_anteil = `co2_fussabdruck_${key}_anteil`;
            if ((!kz[key_anteil] && kz[key_anteil] !== 0) && key !== 'abzug_strom') {
                kz[key_anteil] = 0;
            }
            let factor_show = (kz[key_faktor] || kz[key_faktor] === 0) ? kz[key_faktor] : aq.wert;
            if (kz[key_menge] || key === 'strom' || (key === 'abzug_strom' && kz[key_wert]) || (key === 'angemietet_strom' && kz[key_wert]) || (key === 'eigene_strom' && kz[key_wert])) {
                if (!kz[key_menge]) {
                    kz[key_menge] = 0;
                }
                if (key === 'ladestrom') {
                    factor_show = kz[key_wert] / kz[key_menge];
                }
                const showSecondRow = key === 'strom' && factor_show !== (faktor_strom_co2);
                const nameAddon = showSecondRow
                    ? `(${i18n('über eigenen Stromversorger', 'sys')} - "market-based")`
                    : key === 'strom' ? `(${i18n('Bundesdurchschnitt', 'sys')} - "location-based")` : '';
                if (key !== 'angemietete_fahrzeuge_strom' && key !== 'angemietet_strom') {
                    menge_strom_total += kz[key_menge];
                }
                let row;
                if (key === 'abzug_strom' || key === 'angemietet_strom' || key === 'eigene_strom' || key === 'angemietete_fahrzeuge_strom') {
                    let menge_str = '';
                    let faktor_str = '';

                    // WKETOOL-167: Transparente Berechnung
                    let keyVerbrauch = 's2_raeume_strom';
                    let keyCo2 = 's2_raeume_strom_co2';
                    let field = 'menge';
                    let einheit = 'kWh';

                    if (key === 'angemietete_fahrzeuge_strom') {
                        keyVerbrauch = 'angemietete_fahrzeuge_strom';
                        keyCo2 = 'angemietete_fahrzeuge_strom_co2';
                        field = 'entfernung';
                        einheit = 'km';
                        const key_faktor_map = `co2_fussabdruck_angemietete_fahrzeuge_faktor_map_e`;
                        if (kz[key_faktor_map]) {
                            const arr_names = Object.keys(kz[key_faktor_map]).map((k: string) => {
                                return kz[key_faktor_map][k]['showname'];
                            });
                            name += '\n' + arr_names.join('\n');
                        }
                        menge_str = fn2(kz[key_menge]) + ' km';
                        faktor_str = renderFaktorQuelle(formatNumber(kz[key_wert] / kz[key_menge] * 1000000, 0), 'gCO₂Äq/km', kz[key_quelle_fzg], this.quellen, kz[key_faktor_map]);
                    } else if (key === 'angemietet_strom') {
                        menge_str = fn2(kz[key_menge]) + ' kWh';
                        faktor_str = renderFaktorQuelle(formatNumber(kz[key_wert] / kz[key_menge] * 1000000, 0), 'gCO₂Äq/kWh', kz[key_quelle_raum], this.quellen);
                    }
                    const key_dq = `co2_fussabdruck_${key}_arr_datenqualitaet`;
                    kz[key_datenqualitaet] = getDatenqualitaet(kz[key_dq]);
                    const textVerbrauch = `${fn0(kz[key_menge])} ${einheit}`;
                    const verbrauch = kz[key_menge] ? this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, field) : '';
                    const textEmission = fn2(kz[key_wert]);
                    const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, field);
                    row = [
                        '', `${name} ${nameAddon}`, verbrauch, emission, `${fn2(kz[key_anteil])} %`,
                        faktor_str, transformDatenqualitaet(kz[key_datenqualitaet])
                    ];
                    isSortable = true;
                } else {
                    if (+kz[key_menge] > 0) {
                        co2_storm_total += kz[key_menge] * factor_show;
                        anteil_strom_total += kz[key_anteil];
                        let field, fieldCo2, keyCo2, keyVerbrauch;
                        switch (key) {
                            case 'ladestrom':
                                field = fieldCo2 = 'verbrauch';
                                keyCo2 = `${key}_co2`;
                                keyVerbrauch = `${key}_kwh`;
                                break;
                            case 'strom':
                                field = 'verbrauch';
                                fieldCo2 = 'co2';
                                keyCo2 = keyVerbrauch = 'strom_fremdbezug';
                                break;
                            case 'strom_waerme':
                                field = 'verbrauch';
                                fieldCo2 = 'co2';
                                keyCo2 = 'strom';
                                // keyCo2 = null/*'strom'*/;
                                keyVerbrauch = 'strom';
                                break;
                        }
                        const textVerbrauch = `${fn0(kz[key_menge])} ${aq.einheit}`;
                        const verbrauch = kz[key_menge] ? this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, field) : '';
                        const textEmission = fn2(kz[key_wert]);
                        const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, fieldCo2);
                        row = [
                            '', `${name} ${nameAddon}`, verbrauch, emission, `${fn2(kz[key_anteil])} %`,
                            renderFaktorQuelle(formatNumber(factor_show * 1000000, 0), 'gCO₂Äq/kWh', kz[key_quelle], this.quellen),
                            transformDatenqualitaet(kz[key_datenqualitaet])
                        ];
                    }
                }
                if (key === 'strom') {
                    // row_strom = row;
                    einheit_strom_total = aq.einheit;
                }
                // console.log('ShowSecond: ', showSecondRow, aq.wert, (faktor_strom_co2 / 1000));
                if (row) {
                    let _classes: string[] = [];
                    if (key === 'strom' || true) {
                        classes2_1.push(row_type_item);
                        _classes = row_type_item;
                    } else {
                        classes2_1.push(row_type_item_info);
                        _classes = row_type_item_info;
                    }
                    hasAngemietet = !hasAngemietet ? ['angemietete_fahrzeuge_strom', 'angemietet_strom'].indexOf(key) !== -1 : hasAngemietet;
                    rows2_1.push(row);
                    sum['2.1'] += kz[key_wert];
                    dataSort.push({ name: `${name} ${nameAddon}`, value: kz[key_wert], group: isSortable ? (key === 'abzug_strom' ? 3 : 2) : 1, _row: row, _classes });
                }
                // console.log('ROW2?', item, faktor_strom_co2);
                if (showSecondRow && +kz[key_menge] > 0) {
                    const nameAddon2 = showSecondRow ? `(${i18n('im Vergleich', 'sys')}: ${i18n('Bundesdurchschnitt - "location-based"', 'sys')})` : '';
                    name = showSecondRow ? i18n('Gesamt', 'sys') : name;
                    const key = 's2_strom_bundesdurchschnitt';
                    const field = 'verbrauch';
                    const fieldCo2 = 'co2';
                    const textVerbrauch = `${fn0(kz['strom_bundesdurchschnitt'])} ${aq.einheit}`;
                    // const textVerbrauch = `${fn0(kz[key_menge])} ${aq.einheit}`;
                    const verbrauch = kz['strom_bundesdurchschnitt'] ? this.renderKennzahlenInfo(textVerbrauch, presetJahr, key, field) : '';
                    // const verbrauch = kz[key_menge] ? this.renderKennzahlenInfo(textVerbrauch, presetJahr, key, field) : '';
                    const textEmission = fn2(kz['co2_strom_bundesdurchschnitt']);
                    // const textEmission = fn2(kz[key_menge] * (faktor_strom_co2));
                    const emission = this.renderKennzahlenInfo(textEmission, presetJahr, key, fieldCo2);
                    row_2 = [
                        '', `${name} ${nameAddon2}`, verbrauch, emission, '',
                        renderFaktorQuelle(formatNumber(faktor_strom_co2 * 1000000, 0), 'gCO₂Äq/kWh', aq.quelle, this.quellen),
                        '-'/*transformDatenqualitaet(kz[key_datenqualitaet])*/
                    ];
                }
            }
        });
        // row_strom[2] = `${fn0(menge_strom_total)} ${einheit_strom_total}`;
        // row_strom[3] = fn2(co2_storm_total);
        // row_strom[4] = `${fn2(anteil_strom_total)} %`;

        if (row_2) {
            // row_2[2] = `${fn0(menge_strom_total)} ${einheit_strom_total}`;
            // row_2[3] = fn2(faktor_strom_co2 * menge_strom_total);
            classes2_1.push(row_type_item_info);
            rows2_1.push(row_2);
            dataSort.push({ name: row_2[1], value: faktor_strom_co2 * menge_strom_total, group: 4, _row: row_2, _classes: row_type_item_info });
        }
        this.sortRows(dataSort, rows2_1, classes2_1);
        if (rows2_1.length === 1 && menge_strom_total === 0 && !hasAngemietet) {
            rows2_1 = [['', <i style={{ color: '#888' }}>{i18n('Keine Dateneingabe erfolgt', 'sys')}</i>, '-', '-', '-', '-', '-']];
        }
        // Zeilen 2.2
        const classes2_2: any[] = [];
        const rows2_2: any[] = [];
        sum['2.2'] = 0;
        dataSort = [];
        keys2_2.forEach((key: string) => {
            const co2AequivalentKey = key === 'fernwaerme_mwh' ? 'fernwaerme' : key;
            let einheit = 'kWh';
            let faktor_mengenumrechnung = 1;
            const key_menge = `co2_fussabdruck_${key}_menge`;
            const key_wert = `co2_fussabdruck_${key}_wert`;
            const key_value = `co2_fussabdruck_${key}_value`; // Direkt in "extract" berechnetes CO2
            const key_anteil = `co2_fussabdruck_${key}_anteil`;
            if (!kz[key_anteil] && kz[key_anteil] !== 0) {
                kz[key_anteil] = 0;
            }
            let key_faktor = `faktor_co2_${key}`;
            let key_quelle = `faktor_co2_quelle_${key}`;
            const key_datenqualitaet = `co2_fussabdruck_${key}_datenqualitaet`;
            let item = getCO2Aequivalent(this.props.data, presetJahr, co2AequivalentKey, false);
            let name = item.name;

            const val_verbrauch = kz[key_menge];
            let val_emission = kz[key_value];
            let val_anteil = kz[key_anteil];

            if (key === 'fernwaerme') {
                name = `${i18n('Fernwärme', 'sys')} (kWh)`;
                // Um kWh und mWh separat anzuzeigen, muss mWh vom Gesamtwert abgezogen werden.
                if (kz[`co2_fussabdruck_fernwaerme_value`] > 0 && kz[`co2_fussabdruck_fernwaerme_mwh_value`] > 0) {
                    val_emission = kz[`co2_fussabdruck_fernwaerme_value`] - kz[`co2_fussabdruck_fernwaerme_mwh_value`];
                    val_anteil = (100 / kz.co2_fussabdruck_total) * val_emission;
                    // Siehe processKennzahlenBerechnungCO2.ts Zeile 616
                }
            }
            if (key === 'fernwaerme_mwh') {
                name = `${i18n('Fernwärme', 'sys')} (MWh)`;
                einheit = 'MWh';
            }
            if (key === 'fernkaelte') {
                name = i18n('Fernkälte', 'sys');
                einheit = 'kWh';
            }

            if (presetJahr === 2024 && key === 'fernwaerme') {
                console.log(kz);
                console.log(key_value, kz[key_value]);
                console.log(key_menge, kz[key_menge]);
                console.log(key_wert, kz[key_wert]);
            }

            const factor_show = (val_emission || val_emission === 0)
                ? (val_emission / val_verbrauch)
                : (kz[key_faktor] || kz[key_faktor] === 0)
                    ? kz[key_faktor]
                    : item.wert * (einheit === 'MWh' ? 1000 : 1);

            if (val_verbrauch && (kz[key_wert] || kz[key_wert] === 0)) {
                const fieldVerbrauch = 'verbrauch';
                const fieldCo2 = 'co2';
                const keyCo2 = key === 'fernwaerme' ?
                    'waerme_fernwaerme_kwh' :
                    key === 'fernwaerme_mwh' ? 'waerme_fernwaerme_mwh' : key;
                const keyVerbrauch = keyCo2;
                const textVerbrauch = `${fn0(val_verbrauch)} ${einheit}`;
                const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, fieldVerbrauch);

                // WKETOOL-300: CL 655
                // Mache die folgende Änderung rückgängig, weil sie zur Abweichung bei den Fernwärmeemissionen führt.
                // Diverse Bufixes insb. bei der Location-Based-Berechnung (Sonntag, 1. März 2026 15:22:53)
                // const textEmission = fn2(kz[key_wert]);
                const textEmission = fn2(val_emission);

                const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, fieldCo2);
                const row = [
                    '', name, verbrauch, emission, `${fn2(val_anteil)} %`,
                    renderFaktorQuelle(formatNumber(factor_show * faktor_mengenumrechnung * 1000000, 0), 'gCO₂Äq/' + einheit, kz[key_quelle], this.quellen),
                    transformDatenqualitaet(kz[key_datenqualitaet])
                ];
                classes2_2.push(row_type_item);
                rows2_2.push(row);
                sum['2.2'] += kz[key_wert];
                dataSort.push({ name, value: kz[key_wert], group: 1, _row: row });
            }

            if (key === 'abzug_fernwaerme' && kz[key_wert]) {
                const row = [
                    '', `${i18n('Abzug aus', 'sys')} Scope 3.13.1`, '', fn2(kz[key_wert]), `${fn2(kz[key_anteil])} %`,
                    '', transformDatenqualitaet(kz[key_datenqualitaet])
                ];
                classes2_2.push(row_type_item);
                rows2_2.push(row);
                sum['2.2'] += kz[key_wert];
                dataSort.push({ name: `${i18n('Abzug aus', 'sys')} Scope 3.13.1`, value: kz[key_wert], group: 2, _row: row });
            } else if (key === 'angemietet_kaelte' && kz[key_wert]) {
                const name_w = 'Fernkälte';

                // WKETOOL-167: Transparente Berechnung
                const keyVerbrauch = key.replace('angemietet_', 's2_raeume_');
                const keyCo2 = `${keyVerbrauch}_co2`;
                const field = 'menge';
                // const einheit = 'kWh';
                const textVerbrauch = `${fn0(kz[key_menge])} ${einheit}`;
                const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, field);
                const textEmission = fn2(kz[key_wert]);
                const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, field);
                const row = [
                    '', name_w + ` (Angemietete Räumlichkeiten)`, verbrauch, emission, `${fn2(kz[key_anteil])} %`,
                    '', transformDatenqualitaet(kz[key_datenqualitaet])
                ];

                classes2_2.push(row_type_item);
                rows2_2.push(row);
                sum['2.2'] += kz[key_wert];
                dataSort.push({ name: name_w + ' (Angemietete Räumlichkeiten)', value: kz[key_wert], group: 1, _row: row });
            } else if (key === 'eigene_kaelte' && kz[key_wert]) {
                const name_w = 'Fernkälte';

                // WKETOOL-167: Transparente Berechnung
                const keyVerbrauch = key.replace('eigene_', 's2_raeume_');
                const keyCo2 = `${keyVerbrauch}_co2`;
                const field = 'menge';
                // const einheit = 'kWh';
                const textVerbrauch = `${fn0(kz[key_menge])} ${einheit}`;
                const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, field);
                const textEmission = fn2(kz[key_wert]);
                const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, field);
                const row = [
                    '', `${name_w} (${i18n('Eigene Räumlichkeiten', 'sys')})`, '', emission, `${fn2(kz[key_anteil])} %`,
                    '', transformDatenqualitaet(kz[key_datenqualitaet])
                ];

                classes2_2.push(row_type_item);
                rows2_2.push(row);
                sum['2.2'] += kz[key_wert];
                dataSort.push({ name: `${name_w} (${i18n('Eigene Räumlichkeiten', 'sys')})`, value: kz[key_wert], group: 1, _row: row });
            }
            this.sortRows(dataSort, rows2_2);
        });
        // Zeilen Scope 3
        let hasScope3Multifaktor = false;
        const classes3: any[] = [];
        const rows3: any[] = [];
        temp_row_groups[0] = [];
        sum['3'] = 0;
        const bereichKey = this.apiService.getBereichKey();
        const structs = [
            ...getCO2Scope3StructureVorgelagert(bereichKey, this.modul),
            ...getCO2Scope3StructureNachgelagert(bereichKey, this.modul),
            ...getCO2Scope3StructureAllgemein()
        ];
        const chartDataScope3: any[] = [];
        /*if (+presetJahr === 2020 || +presetJahr === 2021) {
            console.log('KZC', presetJahr , kz);
        }*/
        structs.forEach((struct: any) => {
            const part_addon = struct.part ? '_' + struct.part : '';
            const key_wert = `co2_fussabdruck_s3_ss${struct.subscope + part_addon}_wert`;
            const key_items = `co2_fussabdruck_s3_ss${struct.subscope + part_addon}_items`;
            const key_anteil = `co2_fussabdruck_s3_ss${struct.subscope + part_addon}_anteil`;
            // WKETOOL-113: 476
            // console.log('S3 ', kz[key_wert], struct.name, key_items, kz[key_items], this.props.standortName);
            // '6. Geschäftsreisen', multifaktor: true
            const groups: any[] = [];
            if (!kz[key_anteil] && kz[key_anteil] !== 0) {
                kz[key_anteil] = 0;
            }
            if (kz[key_wert]) {
                let name = struct.force_name
                    ? struct.name
                    : (struct.subscope < 10 ? struct.name.substring(3) : struct.name.substring(4));
                name = i18n2(name);
                const isOpen = this.props.autoOpen ? true : !!this.state.openSubscopes[struct.subscope];
                // console.log('S3O', isOpen, struct.subscope);
                const arrow = !this.props.autoOpen ? <div
                    style={{ fontSize: 11, fontWeight: 'normal', cursor: 'pointer', padding: 5, paddingBottom: 0 }}
                    onClick={() => {
                        // console.log('OPENING', struct.subscope, !isOpen);
                        const openSubscopes: any = this.state.openSubscopes;
                        openSubscopes[struct.subscope] = !isOpen;
                        this.setState({ openSubscopes }, () => {
                            const values: any = this.getValues(chartKey);
                            this.setState({ values, chartKey });
                        });
                    }}
                >
                    <span>{isOpen ? <>&#9660;</> : <>&#9654;</>}</span>
                </div> : null;
                const partAddon = struct.part ? '.' + struct.part : '';

                // WKETOOL-167: Transparente Berechnung
                const emission = this.renderKennzahlenInfo(fn2(kz[key_wert]), presetJahr, `s3_co2_${struct.key}`, 'menge');
                const row = [`3.${struct.subscope + partAddon}`, name, arrow, emission, `${fn2(kz[key_anteil])} %`, '', ''];

                classes3.push(row_type_heading /*row_type_item_s3*/);
                rows3.push(row);
                sum['3'] += kz[key_wert];
                // console.log('S3', struct.name, kz[key_items]);
                if (isOpen) {
                    if (struct.multifaktor) {
                        hasScope3Multifaktor = true;
                    }
                    const dataKategorieSort: any[] = [];
                    let dataSort: any[] = [];
                    let hasKategorien: boolean = false;
                    let lastKategorie: string = null;
                    let sumKategorie: number = 0;

                    const kzConcat = this.getKzConcat(struct, kz[key_items]);
                    (kzConcat || kz[key_items])
                        .sort((a: any, b: any) =>
                            ((a.kategorie_tid || a.name_veranstaltung || 'ZZZ').toString().localeCompare(b.kategorie_tid || b.name_veranstaltung || 'ZZZ').toString())
                        )
                        .forEach((s3_item: any, ir: number) => {
                            // console.log('S3 Item', s3_item);
                            const kategorie: string = s3_item.kategorie_tid || s3_item.name_veranstaltung || null;
                            const isKategorieOpen: boolean = this.props.autoOpen
                                ? true : !!(this.state.openKategorien[struct.subscope] || {})[kategorie];
                            const arrowKategorie = !this.props.autoOpen ? <div
                                key={`${struct.subscope}-${kategorie}`}
                                style={{ fontSize: 11, fontWeight: 'normal', cursor: 'pointer', padding: 5, paddingBottom: 0 }}
                                onClick={() => {
                                    const openKategorien: any = this.state.openKategorien;
                                    openKategorien[struct.subscope] = {
                                        ...(openKategorien[struct.subscope] || {}), [kategorie]: !isKategorieOpen
                                    };
                                    this.setState({ openKategorien }, () => {
                                        const values: any = this.getValues(chartKey);
                                        this.setState({ values, chartKey });
                                    });
                                }}
                            >
                                <span>{isKategorieOpen ? <>&#9660;</> : <>&#9654;</>}</span>
                            </div> : null;
                            if (kategorie && kategorie !== lastKategorie) {
                                const row = ['', kategorie, arrowKategorie, '', '', '', ''];
                                if (ir) {
                                    this.setKategorieRow(dataSort, rows3, sumKategorie, co2_total);
                                    this.sortRows(dataSort, rows3);
                                }
                                dataSort = [];
                                hasKategorien = true;
                                sumKategorie = 0;
                                classes3.push(row_type_heading_kategorie);
                                rows3.push(row);
                                dataKategorieSort.push({ kategorie, name: kategorie, _row: row, _classes: row_type_heading_kategorie });
                            } else if (lastKategorie && !kategorie) {
                                const row = ['', i18n('ohne Kategorie', 'sys'), arrowKategorie, '', '', '', ''];
                                if (ir) {
                                    this.setKategorieRow(dataSort, rows3, sumKategorie, co2_total);
                                    this.sortRows(dataSort, rows3);
                                }
                                dataSort = [];
                                sumKategorie = 0;
                                classes3.push(row_type_heading_kategorie);
                                rows3.push(row);
                                dataKategorieSort.push({ kategorie, name: kategorie, _row: row, _classes: row_type_heading_kategorie });
                            }
                            if (!s3_item.name && s3_item.transportmittel_mobilitaet) {
                                s3_item.name = this.getTransportmittelMobilitaet(struct.key, s3_item.transportmittel_mobilitaet);
                            }
                            const hideRow: boolean = hasKategorien && !isKategorieOpen;
                            const decimals = (s3_item.decimals || s3_item.decimals === 0) ? s3_item.decimals : 0;
                            const einheit = s3_item.einheitShow || s3_item.einheit || '';
                            const menge = s3_item.menge && s3_item.menge > 0 ? this.formatMengeByEinheit(einheit, s3_item) : undefined;
                            const menge2 = this.getMenge2(struct, s3_item);
                            const anteil = `${fn2(100 / co2_total * (s3_item.value || 0))} %`;
                            const faktor = s3_item.faktor || s3_item.faktor === 0 ? formatNumber(s3_item.faktor_show || s3_item.faktor, decimals) : '';
                            // const emission = this.renderKennzahlenInfo(fn2(s3_item.value), presetJahr, 'ss' + struct.subscope + '_' + s3_item.tid, 'co2');
                            const item_name = struct.multifaktor ?
                                s3_item.titel
                                    ? <span>{s3_item.titel}</span>
                                    : <span>{`${i18n('Reise', 'sys')} ${ir + 1}`}&nbsp;<i>({i18n('siehe Dateneingabe', 'sys')}*)</i></span>
                                : s3_item.name + '';

                            // WKETOOL-167: Transparente Berechnung
                            let keyVerbrauch, keyCo2;
                            let faktorMap = s3_item.faktor_map;
                            if (struct.subscope === 3) {
                                const keyTid: string = (s3_item.tid || '').toString();
                                keyVerbrauch = `ss3_${keyTid.startsWith('fzg') ? s3_item.tid : s3_item.name}`;
                                keyCo2 = `ss3_${keyTid.startsWith('fzg') ? s3_item.tid : s3_item.name}_co2`;
                            } else {
                                keyVerbrauch = `s3_${struct.key}_${s3_item.tid}`;
                                keyCo2 = `${keyVerbrauch}_co2`;

                                // faktorKeysMenge & faktorKeysCo2
                                // Siehe auch processKennzahlenBerechnungCO2Scope3.ts
                                let faktorKeysMenge: string[], faktorKeysCo2: string[];
                                const isKampagne = (s3_item.tid + '').startsWith('kampagne_');
                                // 3.4, 3.6, 3.9 -> Nur Übernachtungen
                                const isNurUebernachtung = s3_item.transportmittel === 'uebernachtung' || s3_item.transportmittel_mobilitaet === 'uebernachtung';
                                if (isKampagne || isNurUebernachtung) {
                                    faktorKeysMenge = Object.keys(s3_item.faktor_map || {}).filter((k: string) => k === 'ÜN' && typeof s3_item.faktor_map[k].menge === 'number');
                                    faktorKeysCo2 = Object.keys(s3_item.faktor_map || {}).filter((k: string) => k === 'ÜN' && typeof s3_item.faktor_map[k].wert === 'number');
                                } else {
                                    faktorKeysMenge = Object.keys(s3_item.faktor_map || {}).filter((k: string) => k !== 'ÜN' && typeof s3_item.faktor_map[k].menge === 'number');
                                    faktorKeysCo2 = Object.keys(s3_item.faktor_map || {}).filter((k: string) => typeof s3_item.faktor_map[k].wert === 'number');
                                }
                                if (faktorKeysMenge.length > 0) {
                                    keyVerbrauch += '_gesamt';
                                    keyCo2 += '_gesamt';
                                }
                                if (faktorKeysCo2.length > 0 && faktorMap && Object.keys(faktorMap).length > 0) {
                                    Object.keys(faktorMap).forEach((k: string) => {
                                        if (!faktorKeysCo2.includes(k)) {
                                            delete faktorMap[k];
                                        }
                                    });
                                }
                            }
                            const field = 'menge';
                            const textVerbrauch = [
                                menge ? `${menge} ${this.formatEinheit(einheit) || ''}` : undefined,
                                menge2 || undefined
                            ].filter((txt: string) => typeof txt === 'string').join(' / ');
                            const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, keyVerbrauch, field);
                            const textEmission = fn2(s3_item.value);
                            const emission = this.renderKennzahlenInfo(textEmission, presetJahr, keyCo2, field);
                            const row_item = [
                                '',
                                item_name,
                                verbrauch,
                                emission,
                                anteil,
                                renderFaktorQuelle(faktor, s3_item.faktor_einheit ? s3_item.faktor_einheit_show || s3_item.faktor_einheit : '', s3_item.quelle, this.quellen, faktorMap),
                                transformDatenqualitaet(s3_item.datenqualitaet || 0)
                            ];
                            classes3.push(hideRow ? row_type_item_hidden : row_type_item);
                            rows3.push(row_item);
                            dataSort.push({ name: item_name, value: s3_item.value, _row: row_item });
                            groups.push(row_item);
                            sumKategorie += s3_item.value;
                            dataKategorieSort.push({ kategorie, name: item_name, sum: sumKategorie, value: s3_item.value, _row: row_item, _classes: hideRow ? row_type_item_hidden : row_type_item });
                            lastKategorie = kategorie;
                        });
                    this.setKategorieRow(dataSort, rows3, sumKategorie, co2_total);
                    if (hasKategorien) {
                        this.sortKategorieRows(dataKategorieSort, rows3, classes3);
                    } else {
                        this.sortRows(dataSort, rows3);
                    }
                }
                chartDataScope3.push({ // Farbe wird noch angepasst
                    key: `3.${struct.subscope + partAddon}`, name, value: kz[key_wert], color: this.chartColors[0], legendFormat, labelFormat
                });
                setTempRowGroups(groups, `3.${struct.subscope}${partAddon}`);
            }
        });
        // Farbe für Scope 3 - Chart, da wir jetzt erst die Anzahl wissen
        const s3length = chartDataScope3.length;
        let modS3 = 3;
        if (s3length % 2 === 0) {
            modS3 = 2;
        }
        const scope3colors = getColorsScope3(chartDataScope3.length);
        // chartDataScope3.forEach((cd: any, idx: number) => cd.color = scope3colors[idx]);

        const no_data_row = ['', <i style={{ color: '#888' }}>{i18n('Keine Dateneingabe erfolgt', 'sys')}</i>, '-', '-', '-', '-', '-'];
        if (rows1_1.length === 0) { rows1_1.push(no_data_row); classes1_1.push(row_type_item); }
        if (rows1_2.length === 0) { rows1_2.push(no_data_row); classes1_2.push(row_type_item); }
        if (rows1_3.length === 0) { rows1_3.push(no_data_row); classes1_3.push(row_type_item); }
        if (rows2_1.length === 0) { rows2_1.push(no_data_row); classes2_1.push(row_type_item); }
        if (rows2_2.length === 0) { rows2_2.push(no_data_row); classes2_2.push(row_type_item); }

        const scope1_wert = kz.co2_fussabdruck_scope1;
        const scope1_wert_renewable = kz.co2_fussabdruck_scope1_renewable;
        const scope1_anteil = kz.co2_fussabdruck_scope1_anteil;
        const scope2_wert = kz.co2_fussabdruck_scope2;
        const scope2_anteil = kz.co2_fussabdruck_scope2_anteil;
        const scope3_wert = kz.co2_fussabdruck_scope3;
        const scope3_anteil = kz.co2_fussabdruck_scope3_anteil;
        const scopeOos_wert = kz.co2_fussabdruck_scope_oos;

        const help_strom = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ textAlign: 'center' }}
                styleProps={{ margin: '4px 0 0 -32px' }}
                label={i18n('Hinweise', 'sys')}
                helpKey='co2_scope3_stromvergleich'
                type='info'
                editBar
                useTheme
                useWhite
            />
        );
        const help_oos = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ textAlign: 'center' }}
                styleProps={{ margin: '0 0 0 -26px' }}
                label={i18n('Hinweise', 'sys')}
                helpKey='co2_scope3_outofscope'
                type='info'
                editBar
                useTheme
                useWhite
            />
        );
        const total_wert = kz.co2_fussabdruck_total;
        const zuschlag_wert = kz.co2_fussabdruck_zuschlag || 0;
        // console.log('getValues: ', zuschlag_wert);
        const total_zuschlag_wert = kz.co2_fussabdruck_total_zuschlag;
        const oos_zuschlag_wert = kz.co2_fussabdruck_oos_zuschlag;
        // Help-Icons
        const helpIconFaktor = <WHelpIcon
            data={this.props.data}
            styleDivProps={{ display: 'flex', justifyContent: 'center' }}
            styleProps={{ margin: 0 }}
            label={i18n('Hinweise', 'sys')}
            helpKey='co2_spalte_faktor'
            type='info'
            editBar
            useTheme
            useWhite
        />;
        const helpIconFaktor_oos = <WHelpIcon
            data={this.props.data}
            styleDivProps={{ display: 'flex', justifyContent: 'center' }}
            styleProps={{ margin: 0 }}
            label={i18n('Hinweise', 'sys')}
            helpKey='co2_spalte_faktor'
            type='info'
            editBar
            useTheme
            useWhite
        />;
        const helpIconUnsicherheit = <WHelpIcon
            data={this.props.data}
            styleDivProps={{ display: 'flex', justifyContent: 'center' }}
            styleProps={{ margin: 0 }}
            label={i18n('Hinweise', 'sys')}
            helpKey='co2_spalte_unsicherheit'
            type='info'
            editBar
            useTheme
            useWhite
        />;
        const helpIconUnsicherheit_oos = <WHelpIcon
            data={this.props.data}
            styleDivProps={{ display: 'flex', justifyContent: 'center' }}
            styleProps={{ margin: 0 }}
            label={i18n('Hinweise', 'sys')}
            helpKey='co2_spalte_unsicherheit'
            type='info'
            editBar
            useTheme
            useWhite
        />;
        // Kopfzeilen
        const scope1 = ['SCOPE 1', i18n('Direkte Emissionen', 'sys'), '', 't CO₂ Äq', '%', helpIconFaktor, helpIconUnsicherheit];
        const scope2 = ['SCOPE 2', i18n('Indirekte Emissionen', 'sys'), '', 't CO₂ Äq', '%', helpIconFaktor, helpIconUnsicherheit];
        const scope3 = ['SCOPE 3', i18n('Vor- und nachgelagerte Emissionen', 'sys'), this.renderToggleSubscopes(structs, kz), 't CO₂ Äq', '%', helpIconFaktor, helpIconUnsicherheit];
        const scopeOos = ['Out of Scope', `${i18n('CO₂-Emissionen aus biogenen Anteilen', 'sys')} (${i18n('z.B. Nutzung von Bioenergie', 'sys')})`, help_oos, 't CO₂ Äq', '%', helpIconFaktor_oos, helpIconUnsicherheit_oos];
        const heading1_1 = ['1.1', i18n('Wärmeerzeugung im Unternehmen', 'sys'), '', '', '', '', ''];
        const heading1_2 = ['1.2', i18n('Kraftstoffe', 'sys'), '', '', '', '', ''];
        const heading1_3 = ['1.3', i18n('Technische Gase / Kältemittel', 'sys'), '', '', '', '', ''];
        const heading1_4 = ['1.4', i18n('Benutzerdefinierte Emittenten', 'sys'), '', '', '', '', ''];
        const heading2_1 = ['2.1', i18n('Stromnutzung', 'sys'), help_strom, '', '', '', ''];
        const heading2_2 = ['2.2', i18n('Fernwärme', 'sys'), '', '', '', '', ''];
        const heading2_3 = ['2.3', i18n('Benutzerdefinierte Emittenten', 'sys'), '', '', '', '', ''];
        const headingOos_1 = ['1.1', i18n('Wärmeerzeugung im Unternehmen', 'sys'), '', '', '', '', ''];
        const headingOos_2 = ['1.2', i18n('Kraftstoffe', 'sys'), '', '', '', '', ''];

        const scope1_sum = ['', `${i18n('Gesamtemissionen', 'sys')} SCOPE 1`, '', fn2(scope1_wert), `${fn2(scope1_anteil)} %`, '', ''];
        const empty_row = ['', '...', '', '', '', '', ''];

        rows.push(scope1); custom_row_classes.push(row_type_scope); row_groups.push(null);
        rows.push(heading1_1); custom_row_classes.push(row_type_heading);
        rows = rows.concat(rows1_1);

        custom_row_classes = custom_row_classes.concat(classes1_1);
        setRowGroups(rows1_1, '1.1');


        rows.push(heading1_2); custom_row_classes.push(row_type_heading);
        rows = rows.concat(rows1_2);
        custom_row_classes = custom_row_classes.concat(classes1_2);
        setRowGroups(rows1_2, '1.2');


        rows.push(heading1_3); custom_row_classes.push(row_type_heading);
        rows = rows.concat(rows1_3);
        custom_row_classes = custom_row_classes.concat(classes1_3);
        setRowGroups(rows1_3, '1.3');

        // rows.push(heading1_4);  custom_row_classes.push(row_type_heading);
        rows.push(scope1_sum); custom_row_classes.push(row_type_sum_table); row_groups.push(null);

        // if (scope1_wert_renewable !== scope1_wert && scope1_wert_renewable > 0) {
        //     const emission = this.renderKennzahlenInfo(fn2(scope1_wert_renewable), presetJahr, `scope1_renewable_gesamt`, 'co2');
        //     const scope1_sum_renewable = ['', 'Gesamtemissionen SCOPE 1 (erneuerbar)', '', emission, '', '', ''];
        //     rows.push(scope1_sum_renewable); custom_row_classes.push(row_type_sum_lb); row_groups.push(null);
        // }

        rows.push(empty_row); custom_row_classes.push(row_type_empty); row_groups.push(null);
        rows.push(scope2); custom_row_classes.push(row_type_scope); row_groups.push(null);
        rows.push(heading2_1); custom_row_classes.push(row_type_heading_strom);
        rows = rows.concat(rows2_1);
        custom_row_classes = custom_row_classes.concat(classes2_1);
        setRowGroups(rows2_1, '2.1');

        rows.push(heading2_2); custom_row_classes.push(row_type_heading);
        rows = rows.concat(rows2_2);
        custom_row_classes = custom_row_classes.concat(classes2_2);
        setRowGroups(rows2_2, '2.2');

        // market_based / location_based
        const scope2_wert_mb = kz.co2_fussabdruck_scope2_mb;
        const scope2_wert_lb = kz.co2_fussabdruck_scope2_lb;
        if (scope2_wert_mb !== 0) {
            const scope2_sum_mb = ['', `${i18n('Gesamtemissionen', 'sys')} SCOPE 2 (market-based)`, '', fn2(scope2_wert), `${fn2(scope2_anteil)} %`, '', ''];
            const scope2_sum_lb = ['', `${i18n('Gesamtemissionen', 'sys')} SCOPE 2 (location-based)`, '', fn2(scope2_wert_lb), '', '', ''];
            rows.push(scope2_sum_mb); custom_row_classes.push(row_type_sum_table); row_groups.push(null);
            rows.push(scope2_sum_lb); custom_row_classes.push(row_type_sum_lb); row_groups.push(null);
        } else {
            const scope2_sum = ['', `${i18n('Gesamtemissionen', 'sys')} SCOPE 2 (location-based)`, '', fn2(scope2_wert), `${fn2(scope2_anteil)} %`, '', ''];
            rows.push(scope2_sum); custom_row_classes.push(row_type_sum_table); row_groups.push(null);
        }

        if (sum['3'] > 0) {
            rows.push(empty_row); custom_row_classes.push(row_type_empty); row_groups.push(null);
            rows.push(scope3); custom_row_classes.push(row_type_scope); row_groups.push(null);
            rows = rows.concat(rows3);
            custom_row_classes = custom_row_classes.concat(classes3);
            row_groups = row_groups.concat(temp_row_groups[0] || []);

            // WKETOOL-167: Transparente Berechnung
            const emission = this.renderKennzahlenInfo(fn2(scope3_wert), presetJahr, `s3_co2_gesamt`, 'menge');
            const scope3_sum = ['', `${i18n('Gesamtemissionen', 'sys')} SCOPE 3`, '', emission, `${fn2(scope3_anteil)} %`, '', ''];

            rows.push(scope3_sum); custom_row_classes.push(row_type_sum_table); row_groups.push(null);
        }
        // rows.push(heading2_3);  custom_row_classes.push(row_type_heading);

        if (scope2_wert_mb !== 0) {
            const co2_total_lb = kz.co2_fussabdruck_total_lb; //  + kz.co2_fussabdruck_scope2_verbrauch_mb * faktor_strom_co2;
            const total_sum_lb = ['', `${i18n('GESAMTERGEBNIS', 'sys')} (location-based)`, '', fn2(co2_total_lb), '', '', ''];
            const total_sum_mb = ['', `${i18n('GESAMTERGEBNIS', 'sys')} (market-based)`, '', fn2(total_wert), `100%`, '', ''];
            rows.push(total_sum_lb); custom_row_classes.push(row_type_total_lb); row_groups.push(null);
            rows.push(total_sum_mb); custom_row_classes.push(row_type_total2_help); row_groups.push(null);
        } else {
            const total_sum = ['', `${i18n('GESAMTERGEBNIS', 'sys')} (location-based)`, '', fn2(total_wert), '100,00 %', '', ''];
            rows.push(total_sum); custom_row_classes.push(row_type_total_help); row_groups.push(null);
        }

        const total_sum2 = ['', i18n('mit Sicherheitszuschlag', 'sys'), this.renderZuschlagEingabe, fn2(total_zuschlag_wert), '', '', ''];
        // rows.push(total_sum2); custom_row_classes.push(row_type_total2); row_groups.push(null);
        rows.push(total_sum2); custom_row_classes.push(row_type_total_help_0mt); row_groups.push(null);

        // out of Scope ***************************************************
        if (co2_oos && co2_oos > 0) {
            rows.push(empty_row); custom_row_classes.push(row_type_empty); row_groups.push(null);
            rows.push(empty_row); custom_row_classes.push(row_type_empty); row_groups.push(null);
            rows.push(scopeOos); custom_row_classes.push(row_type_scope_oos); row_groups.push(null);

            const key_items_oos1 = `co2_fussabdruck_s3_oos1_items`;
            const key_items_oos2 = `co2_fussabdruck_s3_oos2_items`;
            const wert_oos1 = kz['co2_fussabdruck_s3_oos1_wert'];
            const wert_oos2 = kz['co2_fussabdruck_s3_oos2_wert'];

            if (wert_oos1 && wert_oos1 > 0) {
                rows.push(headingOos_1); custom_row_classes.push(row_type_heading_oos);
                kz[key_items_oos1].forEach((oos_item: any, ir: number) => {
                    const decimals = (oos_item.decimals || oos_item.decimals === 0) ? oos_item.decimals : 0;
                    const menge = oos_item.menge && oos_item.menge > 0 ? fn0(oos_item.menge) : undefined;
                    const einheit = oos_item.einheit || '';
                    const anteil = `${fn2(100 / co2_oos * (oos_item.value || 0))} %`;
                    const faktor = oos_item.faktor || oos_item.faktor === 0 ? formatNumber(oos_item.faktor, decimals) : '';
                    const item_name = oos_item.name + '';

                    // WKETOOL-167: Transparente Berechnung
                    const textVerbrauch = `${menge ? `${menge} ` : ''}${this.formatEinheit(einheit) || ''}`;
                    const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, `${oos_item.kennKey}_gesamt`, 'menge');
                    const emission = this.renderKennzahlenInfo(fn2(oos_item.value), presetJahr, `${oos_item.kennKey}_co2_gesamt`, 'menge');
                    const row_item = [
                        '', item_name, verbrauch, emission, anteil,
                        renderFaktorQuelle(faktor, oos_item.faktor_einheit ? oos_item.faktor_einheit : '', oos_item.quelle, this.quellen),
                        transformDatenqualitaet(oos_item.datenqualitaet || 0)
                    ];

                    rows.push(row_item); custom_row_classes.push(row_type_item);
                });
            }

            if (wert_oos2 && wert_oos2 > 0) {
                rows.push(headingOos_2); custom_row_classes.push(row_type_heading_oos);
                kz[key_items_oos2].forEach((oos_item: any, ir: number) => {
                    const decimals = (oos_item.decimals || oos_item.decimals === 0) ? oos_item.decimals : 0;
                    const menge = oos_item.menge && oos_item.menge > 0 ? fn0(oos_item.menge) : undefined;
                    const einheit = oos_item.einheit || '';
                    const anteil = `${fn2(100 / co2_oos * (oos_item.value || 0))} %`;
                    const faktor = oos_item.faktor || oos_item.faktor === 0 ? formatNumber(oos_item.faktor, decimals) : '';
                    const item_name = oos_item.name + '';

                    // WKETOOL-167: Transparente Berechnung
                    const textVerbrauch = `${menge ? `${menge} ` : ''}${this.formatEinheit(einheit) || ''}`;
                    const verbrauch = this.renderKennzahlenInfo(textVerbrauch, presetJahr, `${oos_item.kennKey}_gesamt`, 'menge');
                    const emission = this.renderKennzahlenInfo(fn2(oos_item.value), presetJahr, `${oos_item.kennKey}_co2_gesamt`, 'menge');
                    const row_item = [
                        '', item_name, verbrauch, emission, anteil,
                        renderFaktorQuelle(faktor, oos_item.faktor_einheit ? oos_item.faktor_einheit : '', oos_item.quelle, this.quellen),
                        transformDatenqualitaet(oos_item.datenqualitaet || 0)
                    ];

                    rows.push(row_item); custom_row_classes.push(row_type_item);
                });
            }

            // WKETOOL-167: Transparente Berechnung
            const emission = this.renderKennzahlenInfo(fn2(scopeOos_wert), presetJahr, `oos_co2_gesamt`, 'menge');
            const scopeOos_sum = ['', i18n('Gesamtemissionen aus biogenen Anteilen', 'sys'), '', emission, `${fn2(100)} %`, '', ''];

            rows.push(scopeOos_sum); custom_row_classes.push(row_type_sum_table_oos);
        }

        // console.log('CHARTKEY', chartKey);
        let chartData;
        switch (chartKey) {
            case 'Scope 1':
                chartData = [
                    { key: '1.1', name: i18n('Wärmeerzeugung im Unternehmen', 'sys'), value: sum['1.1'], color: this.chartColors[0], legendFormat, labelFormat },
                    { key: '1.2', name: i18n('Kraftstoffe', 'sys'), value: sum['1.2'], color: this.chartColors[1], legendFormat, labelFormat },
                    { key: '1.3', name: i18n('Technische Gase / Kältemittel', 'sys'), value: sum['1.3'], color: this.chartColors[2], legendFormat, labelFormat },
                ];
                break;
            case 'Scope 2':
                chartData = [
                    { key: '2.1', name: i18n('Stromnutzung', 'sys'), value: sum['2.1'], color: this.chartColors[0], legendFormat, labelFormat },
                    { key: '2.2', name: i18n('Fernwärme', 'sys'), value: sum['2.2'], color: this.chartColors[1], legendFormat, labelFormat },
                ];
                break;
            case 'Scope 3':
                chartData = chartDataScope3;
                // console.log('CHART S3: ', chartData);
                break;
            default:
                const legendFormat2 = '[name] [[value] t CO₂ Äq / [percentage] %]';
                chartData = [
                    { key: '1', name: 'Scope 1', value: scope1_wert, color: this.chartColors[0], legendFormat: legendFormat2 },
                    { key: '2', name: 'Scope 2', value: scope2_wert, color: this.chartColors[1], legendFormat: legendFormat2 },
                    { key: '3', name: 'Scope 3', value: scope3_wert, color: this.chartColors[2], legendFormat: legendFormat2 },
                ];
            // console.log(chartData);
        }
        rows.forEach((row: any[]) => this.modul !== 'cfm' ? row.splice(6, 1) /* Datenqualität */ : null);
        custom_row_classes.forEach((classes: any[]) => this.modul !== 'cfm' ? classes.splice(6, 1) /* Datenqualität */ : null);
        chartData = this.processData(chartData);
        // console.log(chartData);
        return { rows, custom_row_classes, chartData, flags: { hasScope3Multifaktor }, row_groups };
    }

    formatEinheit(einheit: string) {
        if (typeof einheit !== 'string') {
            return einheit;
        }
        return einheit.replace(/euro/gi, '€')
    }

    formatFaktorByName(name: string, faktor: number) {
        if (name === i18n('Biogas', 'sys')) {
            return fn3d(faktor);
        }
        return formatNumber(faktor, 0);
    }

    formatMengeByEinheit(einheit: string, item: any) {
        let menge = item.menge;
        if (item.mengeShow) {
            menge = item.mengeShow;
        }
        if (einheit === 'Tonnen') {
            return fn3d(item.menge);
        }
        return fn0(menge);
    }

    getMenge2(struct: any, item: any) {
        if (['transport_vorgelagert', 'reisen', 'transport_nachgelagert'].indexOf(struct.key) !== -1) {
            if (item.uebernachtungen_orig === 1 && item.uebernachtungen_anzahl > 0
                && (item.transportmittel_mobilitaet || item.transportmittel)
                && item.modus !== 'user_specific'
            ) {
                const personen = ['transport_vorgelagert', 'reisen'].indexOf(struct.key) !== -1
                    ? (item.teilnehmer || 1) /* Anzahl übernachtender Personen */
                    : (['transport_nachgelagert'].indexOf(struct.key) !== -1 ? (item.personen || 1) /* Personenanzahl */ : 1);
                return `${item.uebernachtungen_anzahl * personen} ÜN`;
            }
        }
    }

    getValuesDiagT2(chartKey?: string,) {
        chartKey = chartKey || 'Scope 1';
        const val = this.getValues(chartKey);
        const quellen: any = this.quellen;
        const valVorjahr = this.getValues(chartKey, this.state.jahr - 1);
        if (Array.isArray(val.chartData) && Array.isArray(valVorjahr.chartData)) {
            val.chartData.forEach((r: any, idx: number) => {
                const fnd = valVorjahr.chartData.find((r2: any) => r2.key === r.key && r2.name === r.name);
                if (fnd) {
                    fnd.color = this.colorVorjahreswerte;
                    fnd.name += ` (${i18n('Vorjahr', 'sys')})`;
                    val.chartData[idx].value2 = fnd.value;
                    val.chartData[idx].extraValues = { value2: fnd };
                }
            });
        }
        this.quellen = quellen;
        return val;
    }

    getZuschlagItem(jahr?: number): any {
        if (!jahr) {
            jahr = this.state.jahr;
        }
        const itemFound = this.props.data[IDs.ENT_CO2_SICHERHEITSZUSCHLAG].find((item: any) =>
            +item.jahr === +jahr
            && (+item.standort_tid_orig === +this.props.standortTid || this.props.standortName === i18n('Alle Standorte', 'sys') && item.standort_tid === -1)
        );
        // console.log('Zuschlag', itemFound, this.props.data[IDs.ENT_CO2_SICHERHEITSZUSCHLAG], this.props.standortTid, this.props.standortName);
        return itemFound;
    }

    processData(chartData: any[]): any[] {
        const sum = chartData.reduce((p, c) => p + (c.value || 0), 0);
        return chartData.filter((r: any) => {
            r.percentage = sum > 0 ? ((r.value || 0) / sum * 100) : 0;
            if (r.legendFormat) {
                r.legend = r.legendFormat.replace('[key]', r.key).replace('[name]', r.name).replace('[value]', fn2(r.value)).replace('[percentage]', fn2(r.percentage));
            } else {
                r.legend = `${r.name} [${fn2(r.percentage)} %]`;
            }
            // console.log(r.value, sum, r.percentage, fn2(r.percentage));
            // Scope 0% im Diagramm nicht erscheint
            // return fn2(r.percentage) !== '0,00';
            // Erstmal den Filter aufheben.
            return true;
        });
    }

    render(): JSX.Element {
        const konfiguration: any[] = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const disabledCO2Komplex: boolean = !IDs.FLAG_ENABLE_SCOPE3
            || !konfiguration.some((param: any) => param.co2_fussabdruck_orig === 1);
        const { chartOnly, contentOnly, hideChartTitle, onChartSelectChange, diagramStyle, parentElement } = this.props;
        const { values, jahr, chartKey, chartKeyT2 } = this.state;
        if (!values) {
            return null;
        }
        const zuschlagItemCheck = this.getZuschlagItem();
        const zuschlagKeyCheck = `${this.props.standortTid}_${this.state.jahr}_${zuschlagItemCheck ? zuschlagItemCheck.zuschlag : 0}`;
        // Zuschlag prüfen
        // const jahrUse = this.state.jahr;
        // const itemFound = this.props.data[IDs.ENT_CO2_SICHERHEITSZUSCHLAG].find((item: any) => {
        //     return +item.jahr === +jahrUse &&
        //         (item.standort_tid_orig === this.props.standortTid || this.props.standortName === i18n('Alle Standorte', 'sys') && item.standort_tid === -1);
        // });
        if (zuschlagKeyCheck !== this.zuschlagKey) {
            this.zuschlagKey = zuschlagKeyCheck;
            window.setTimeout(() => {
                const zuschlagItem = this.getZuschlagItem();
                // console.log('RenderZKstate: ', zuschlagItem);
                this.setState({ zuschlag: zuschlagItem ? zuschlagItem.zuschlag : 0 }, () => {
                    const vals = this.getValues(this.state.chartKey);
                    this.setState({ values: vals });
                });
            }, 100);
        }
        let widthCols: number[][] | number[] = [
            [0.75, 0.75],   // [0] Scope
            [4, 3],         // [1] Emissionsquelle
            [1.3, 1.3],     // [2] Menge / Einheit
            [1, 1],         // [3] Emissionen
            [0.75, 0.75],   // [4] Anteil
            [1.7, 1.7],     // [5] CO₂-Faktor / Quelle
            [1, 1.1],       // [6] Datenqualität
        ];
        const indexModul: number = this.modul === 'cfm' ? 1 : 0;
        widthCols = [...widthCols.map((item: number[]) => item[indexModul])];
        const calcWidth: number[] = [...widthCols];
        if (this.modul !== 'cfm') {
            calcWidth.splice(6, 1); // Datenqualität
        }
        const baseWidth = 100 / calcWidth.reduce((sum: number, value: number) => sum + value, 0); // Bitte immer in Prozent angeben
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;
        const customStyle = { backgroundColor: '#728A49', color: '#fff', fontWeight: 'normal' };
        const diagT1Val = this.getValues(); // diagramsT1
        // const diagT2Val = this.getValues(chartKeyT2 || 'Scope 1'); // diagramsT2
        const diagT2Val = this.getValuesDiagT2(chartKeyT2 || 'Scope 1');
        // console.log('base-width', baseWidth);
        const config: any = {
            noRenderRowsCheck: true,
            // width: 1700,
            tableStyle: { flex: 'none', width: 850 },
            diagramsStyle: { flex: 'none', width: 660 }, // 470 // 650
            titel0: unternehmen,
            titel1: `${i18n('CO₂-Fußabdruck', 'sys')}/${i18n('Jahr', 'sys')} ${jahr}`,
            // titel2: (this.props.standortName || '').toString().replace(/(^(Veranstaltung|Standort)\:\ )/, ''),
            titel2: (this.props.standortName || '').toString().replace(new RegExp("^(\\b" + i18n('Veranstaltung', 'sys') + "\\b|\\b" + i18n('Standort', 'sys') + "\\b)\:\ "), ''),
            filename: `${i18n('Auswertung', 'sys')}_CO2_${i18n('Fussabdruck', 'sys')}_${i18n('Jahr', 'sys')}_${jahr}.pdf`,
            report: { data: (this.props.data || {})[IDs.ENT_REPORT] || [], standort: +this.props.standortTid || 0, key: 'co2_details' },
            baseWidth: baseWidth,
            values,
            header: {
                blocks: [
                    {
                        label: '',
                        customStyle,
                        width: `${baseWidth * widthCols[0]}%`
                    },
                    {
                        label: i18n('Emissionsquelle', 'sys'),
                        customStyle,
                        width: `${baseWidth * widthCols[1]}%`
                    },
                    {
                        label: `${i18n('Menge', 'sys')} / ${i18n('Einheit', 'sys')}`,
                        customStyle,
                        width: `${baseWidth * widthCols[2]}%`
                    },
                    {
                        label: i18n('Emissionen', 'sys'),
                        customStyle,
                        width: `${baseWidth * widthCols[3]}%`
                    },
                    {
                        label: i18n('Anteil', 'sys'),
                        customStyle,
                        width: `${baseWidth * widthCols[4]}%`
                    },
                    {
                        label: `${i18n('CO₂-Faktor', 'sys')} / ${i18n('Quelle', 'sys')}`,
                        customStyle,
                        width: `${baseWidth * widthCols[5]}%`
                    },
                    {
                        label: i18n('Datenqualität', 'sys'),
                        customStyle,
                        width: `${baseWidth * widthCols[6]}%`
                    }
                ]
            },
            rows: values.rows,
            row_classes: [, , , , , , , , ,],
            rows_width: widthCols.map((width: number) => baseWidth * width),
            custom_row_classes: values.custom_row_classes,
            custom_layout: i18n('Jahresauswertung', 'sys'),
            diagramsPosition: 'right',
            diagrams: []
        };
        if (this.modul !== 'cfm') {
            config.header.blocks.splice(6, 1); // Datenqualität
        }

        if (parentElement === 'EnergieCockpit') {
            config.diagrams = [{
                type: 'PieChart',
                layout: 'row',
                title: `${i18n('Auswertung CO₂-Fußabdruck', 'sys')} / ${i18n('Jahr', 'sys')} ${jahr} / ${chartKey || ('Scopes 1-' + (disabledCO2Komplex ? '2' : '3'))}`,
                hideTitle: hideChartTitle,
                titlePdf: `${i18n('Auswertung CO₂-Fußabdruck', 'sys')} / ${i18n('Jahr', 'sys')} ${jahr} / ${chartKey || ('Scopes 1-' + (disabledCO2Komplex ? '2' : '3'))}`,
                legend: values.chartData.map((d: any) => d.legend),
                legendIconColor: values.chartData.map((d: any) => d.color),
                data: values.chartData,
                lineColor: this.chartColors,
                containerSize: { width: '100%' /* !importent */ },
                labelFormat: '[key]', // '[key] [name] [[value] t CO₂ Äq / [percentage] %]'
                chartSelectable: disabledCO2Komplex ? {
                    'Scopes 1-2': ['scope_1', 'scope_2'],
                    'Scope 1': ['scope_1'],
                    'Scope 2': ['scope_2'],
                } : {
                    'Scopes 1-3': ['scope_1', 'scope_2', 'scope_3'],
                    'Scope 1': ['scope_1'],
                    'Scope 2': ['scope_2'],
                    'Scope 3': ['scope_3']
                },
                selectedChartKey: chartKey,
                diagramStyle: { height: 310, ...(diagramStyle || {}) }, // 310
                /* customStyle: { marginTop: '-0 !important'}, */
                customStyle: { marginTop: -190 },
                customLegendStyle: { height: 120 },
                hideLabelsFilter: (data: any, rows: any[], index: number) => {
                    return (data.percentage || 0) < 2;
                },
                chartSelectChange: this.setChartSelect,
                getChartSelector: ((element: JSX.Element) => typeof this.props.getChartSelector === 'function' && this.props.getChartSelector(element)),
                // elemSelectPosition: 'title'
            }];
        } else {
            config.diagramLayout = 'column';
            config.diagrams = [
                {
                    type: 'PieChart',
                    layout: 'row',
                    title: `${i18n('Auswertung CO₂-Fußabdruck', 'sys')} / ${i18n('Jahr', 'sys')} ${jahr} / ${'Scopes 1-' + (disabledCO2Komplex ? '2' : '3')}`,
                    hideTitle: hideChartTitle,
                    titlePdf: `${i18n('Auswertung CO₂-Fußabdruck', 'sys')} / ${i18n('Jahr', 'sys')} ${jahr} / ${'Scopes 1-' + (disabledCO2Komplex ? '2' : '3')}`,
                    legend: diagT1Val.chartData.map((d: any) => d.legend),
                    legendIconColor: diagT1Val.chartData.map((d: any) => d.color),
                    data: diagT1Val.chartData,
                    lineColor: this.chartColors,
                    containerSize: { width: '100%' /* !importent */ },
                    labelFormat: '[key]', // '[key] [name] [[value] t CO₂ Äq / [percentage] %]'
                    diagramStyle: { height: 310, ...(diagramStyle || {}) },
                    hideLabelsFilter: (data: any, rows: any[], index: number) => {
                        return (data.percentage || 0) < 2;
                    },
                    customStyle: { marginTop: -240 }
                },
                {
                    type: 'SimpleBarChart',
                    title: `${i18n('Auswertung CO₂-Fußabdruck', 'sys')} / ${i18n('Jahr', 'sys')} ${jahr} / ${chartKeyT2 || 'Scopes 1'}`,
                    titlePdf: `${i18n('Auswertung CO₂-Fußabdruck', 'sys')} / ${i18n('Jahr', 'sys')} ${jahr} / ${chartKeyT2 || 'Scopes 1'}`,
                    data: diagT2Val.chartData,
                    X_dataKey: 'key',
                    Y_dataKey: ['value2', 'value'],
                    diagramStyle: { minHeight: 320, height: 'unset', ...(diagramStyle || {}) },
                    chartSelectable: disabledCO2Komplex ? {
                        'Scope 1': ['scope_1'],
                        'Scope 2': ['scope_2'],
                    } : {
                        'Scope 1': ['scope_1'],
                        'Scope 2': ['scope_2'],
                        'Scope 3': ['scope_3']
                    },
                    selectedChartKey: chartKeyT2,
                    chartSelectChange: this.setChartSelect2,
                    customLegends: [{ color: this.colorVorjahreswerte, legend: i18n('Vorjahreswerte', 'sys') }],
                    legendProps: { style: { flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' } },
                    containerSize: { width: 580 }, // 420
                    elemSelectPosition: 'title' // | 'chart'
                    // legendProps: { style: { justifyContent: 'flex-start' } }
                }
            ];
        }

        if (typeof onChartSelectChange === 'function') {
            onChartSelectChange(config.diagrams[0]);
            this.contextService.set('co2_detail_chartKey', chartKey);
        }

        const helpIcon = (
            <WHelpIcon
                data={this.props.data}
                label={i18n('Datenauswertung - Hinweise', 'sys')}
                helpKey='datenauswertung_co2_details'
                type='info_2'
                styleProps={{ color: '#000', backgroundColor: '#fff' }}
                editBar
                useTheme
                useWhite
            />
        );

        const arr_header_form_elements: any[] = [
            {
                elem: <DatenauswertungJahrauswahlEinzeln
                    jahrMax={this.state.jahrMax}
                    jahrMin={this.state.jahrMin}
                    jahr={this.state.jahr}
                    onJahrChange={(jahr: number) => {
                        this.setState({ jahr: +jahr }, () => {
                            this.contextService.set('jahr_cockpit', jahr);
                        });
                    }}
                    renderClean={true}
                />,
                wrapClass: 'datenauswertungContentLeft'
            },
            { elem: this.renderColumnsSort(), wrapClass: 'datenauswertungContentLeft' },
            {
                elem: isVeranstaltung(this.props.data, this.props.standortTid) ? this.renderVeranstaltung() : this.renderStandort(),
                wrapClass: 'datenauswertungContentGrow'
            },
            { elem: <span className={style.datenauswertungArrow}>🡆</span>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>{i18n('Optionen', 'sys')}{this.renderEditIcon()}</label>{this.renderEingabeButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.renderBemerkungButton()}</>, wrapClass: 'datenauswertungContentRight' },
            { elem: <><label>&nbsp;</label>{this.state.renderButton}</>, wrapClass: 'datenauswertungContentRight' },
            // { elem: <><label>&nbsp;</label><div style={{ padding: 5, paddingRight: 20 }}>{helpIcon}</div></>, wrapClass: 'datenauswertungContentRight' }
        ];

        config.width = 1300;

        return (
            <div>
                {!this.props.setJSXdirect && !chartOnly && !contentOnly &&
                    <div className={datenauswertungStyle.datenauswertungOuterFormContainer}>
                        <DatenauswertungFormWrapper
                            elements={arr_header_form_elements}
                        />
                    </div>
                }
                <DatenauswertungGenerisch
                    id={this.props.id}
                    chartOnly={chartOnly}
                    contentOnly={contentOnly}
                    config={config}
                    orientation='portrait'
                    setRenderButton={(renderButton: JSX.Element) => this.setState({ renderButton })}
                    setJSXdirect={this.props.setJSXdirect}
                    callbackPages={typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null}
                    pdfButtonStyle={{ color: 'white', backgroundColor: '#686868' }}
                    pdfLayoutless={this.props.pdfLayoutless}
                    // funcExternalElementUnderTable={this.renderZuschlag}
                    funcExternalElementExtrapage={this.renderQuellen}
                />
            </div>
        );
    }

    renderBemerkungButton(): JSX.Element {
        return (
            <DatenauswertungReportKonfigurationBemerkungButton
                data={this.props.data}
                standort={this.props.standortTid}
                type='co2_details'
                styleProps={{ color: 'white', backgroundColor: '#686868' }}
                noLabel={true}
            />
        );
    }

    renderColumnsSort(): JSX.Element {
        return <>
            <label>{i18n('Sortierung Subscopes', 'sys')}{this.renderEditIcon()}</label>
            <select
                value={this.state.columnsSortIndex}
                onChange={(event: any) => this.setState({ columnsSortIndex: event.target.value })}
            >
                {this.columnsSortOptions.map((item: any, index: number) =>
                    <option key={`option-${index}`} value={index}>{item.name}</option>
                )}
            </select>
        </>;
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>Sortierung Subscopes:</div>
                <select
                    style={{ marginLeft: 5, padding: 2 }}
                    value={this.state.columnsSortIndex}
                    onChange={(event: any) => this.setState({ columnsSortIndex: event.target.value })}
                >
                    {this.columnsSortOptions.map((item: any, index: number) =>
                        <option key={`option-${index}`} value={index}>{item.name}</option>
                    )}
                </select>
            </div>
        );
    }

    renderEditIcon() {
        return '';
        return (
            <>
                <span className={style.datenauswertungEditIcon} />
                <span><a href='#'>Info</a></span>
            </>
        );
    }

    renderEigenstromHeader() {
        const values = this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM];
        const typen = this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN];
        const typen_filtered = typen.filter((item: any) => values.some((aw: any) =>
            item.typ === 'S' && aw.anlagen_eigenstrom_typ_tid_orig === item.tid
        ));

        if (!typen_filtered || typen_filtered.length === 0) {
            return i18n('Keine erneuerbaren Energien vorhanden', 'sys');
        }
        const arr = typen_filtered.map((item: any, idx: number) =>
            <React.Fragment key={`typ-${idx}`}>
                &nbsp;{item.name}&nbsp;{((idx + 1) < typen_filtered.length ? '/' : '')}
            </React.Fragment>
        );
        return [<React.Fragment key={`typ-`}>{`${i18n('Eigenstrom', 'sys')}\n`}</React.Fragment>, ...arr];
    }

    renderEingabeButton(): JSX.Element {
        const { jahr } = this.state;
        return (
            <WActionButton
                label={i18n('Dateneingabe', 'sys')}
                insideText={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                tooltip={i18n('zur E-Tool Eingabe wechseln', 'sys')}
                key='dateneingabe'
                action='editNote'
                styleProps={{ color: 'var(--color-button-text)', backgroundColor: 'var(--color-section-main)' }}
                onAction={() => this.props.onRoutingChange({
                    ...(getRoutingCO2Scope3(this.props.data, this.props.standortTid)), jahr, key: 'inputScope3'
                })}
            />
        );
    }

    renderToggleSubscopes(structures: any[], kennzahlen: any): JSX.Element {
        const subscopes: number[] = [];
        let isOpen: boolean = false;
        (structures || []).forEach((structure: any) => {
            if (!(kennzahlen || {})[`co2_fussabdruck_s3_ss${structure.subscope}${structure.part ? `_${structure.part}` : ''}_wert`]) {
                return;
            }
            subscopes.push(structure.subscope);
            isOpen = !(this.state.openSubscopes || {})[structure.subscope] ? true : isOpen;
        });
        isOpen = this.props.autoOpen ? true : !isOpen;
        return (!this.props.autoOpen
            ? <div
                style={{
                    fontSize: 11, fontWeight: 'normal', textAlign: 'left', lineHeight: 1, marginLeft: 5, paddingLeft: '5pt',
                    cursor: 'pointer'
                }}
                onClick={() => {
                    const openSubscopes: any = {};
                    if (!isOpen) {
                        subscopes.forEach((subscope: number) => openSubscopes[subscope] = true);
                    }
                    this.setState({ openSubscopes }, () => {
                        const chartKey: string = this.state.chartKey || null;
                        const values: any = this.getValues(chartKey);
                        this.setState({ chartKey, values });
                    });
                }}
            >
                <span>
                    {isOpen
                        ? <>&#9660; {!this.props.autoOpen ? i18n('Alle Ausblenden', 'sys') : ''}</>
                        : <>&#9654; {!this.props.autoOpen ? i18n('Alle Anzeigen', 'sys') : ''}</>
                    }
                </span>
            </div>
            : null
        );
    }

    renderDisclaimer(isPdf: boolean): JSX.Element {
        return <WpdfView pdf={isPdf} style={{ paddingRight: 20 }}>
            <WpdfText pdf={isPdf} style={{ display: 'inline', fontWeight: 'bold', fontStyle: 'italic', color: '#444', fontSize: 11 }}>{i18n('Hinweis', 'sys')}: &nbsp;</WpdfText>
            <WpdfText pdf={isPdf} style={{ display: 'inline', fontStyle: 'italic', color: '#888', fontSize: 11 }}>
                {i18n('Den oben dargestellten Ergebnissen bzw. Einzelwerten liegen anerkannte Berechnungsstandards zugrunde, die im E-Tool mit größter Sorgfalt implementiert und von unabhängiger Stelle geprüft wurden. Die korrekte Berechnung dieser Werte hängt wesentlich von den eingegebenen Daten ab, für deren Vollständigkeit, Richtigkeit oder Aktualität der Nutzer verantwortlich ist; die dargestellten Einzelwerte sind nicht verifiziert.', 'sys')}
            </WpdfText>
        </WpdfView>;
    }

    renderQuellen(isPdf: boolean): JSX.Element | boolean {
        // if (isPdf && !this.state.showQuellen) {
        //     return false;
        // }
        const fontSize = isPdf ? 10 : 12;
        return <WpdfView pdf={isPdf} style={{ display: 'flex', flexDirection: 'column', ...(!isPdf && { paddingLeft: 20 }) }}>
            {this.renderDisclaimer(isPdf)}
            <WpdfView pdf={isPdf} key='quelle_titel_view'>
                <WpdfText pdf={isPdf} key='quelle_titel' style={{ fontSize: fontSize + 4, fontWeight: 'bold', marginBottom: 10, marginTop: 20 }}>
                    {isPdf
                        ? i18n('Quellen', 'sys')
                        : <span onClick={() => this.setState({ showQuellen: !this.state.showQuellen })} style={{ cursor: 'pointer' }}>
                            Quellen {(isPdf || this.state.showQuellen) ? '▼' : '▶'}
                        </span>
                    }
                </WpdfText>
            </WpdfView>
            {(isPdf || this.state.showQuellen) && this.quellen.map((q: string, idx: number) =>
                <WpdfView
                    pdf={isPdf}
                    key={`quelle${idx}`}
                    style={{
                        display: 'flex', flexDirection: 'row', marginTop: 3,
                        ...(!isPdf && ((idx + 1) === this.quellen.length) && { marginBottom: 20 })
                    }}
                >
                    <WpdfView
                        pdf={isPdf}
                        style={{
                            textAlign: 'center', backgroundColor: '#f7f7f7', fontSize,
                            ...(isPdf ? { flexBasis: '6%', borderLeft: '10pt solid white' } : { width: 20, marginLeft: 10 }),
                        }}
                    >
                        <WpdfText pdf={isPdf}>{idx + 1}</WpdfText>
                    </WpdfView>
                    <WpdfView
                        pdf={isPdf}
                        key={`quelle_text${idx}`}
                        style={{ paddingLeft: 5, fontSize, boxSizing: 'border-box', ...(isPdf && { flexBasis: '94%' }) }}
                    >
                        {this.renderQuelle(q, isPdf)}
                    </WpdfView>
                </WpdfView>
            )}
        </WpdfView>;
        /*<WpdfText pdf = {isPdf} style={{flex: 1, maxWidth: '20px', marginLeft: '3px', textAlign: 'center', backgroundColor: '#BBB', fontSize: '12px'}}>
            {idx + 1}
        </WpdfText>
        <WpdfText pdf = {isPdf} style={{flex: 1, fontSize: '12px', marginLeft: '10px'}}>{q}</WpdfText>*/
    }

    renderQuelle(q: string, isPdf: boolean) {
        if (q.indexOf(';;') === -1) {
            return <WpdfText pdf={isPdf} style={{ display: 'block' }}>
                {q}
            </WpdfText>;
        }
        const arr = q.split(';;');
        return <WpdfView pdf={isPdf}>
            {arr.map((item: string) => <WpdfText pdf={isPdf} style={{ display: 'block' }}>
                {item}
            </WpdfText>)}
        </WpdfView>;
    }

    renderStandort(): JSX.Element {
        const disabled: boolean = this.props.data.MODUL_SELECTED === 'steuer';

        return (
            <StandortAuswahl
                label={i18n('Standort', 'sys')}
                data={this.props.data}
                standort={this.props.standortTid}
                disabled={disabled}
                filter={(standort: any, callback: (visible: boolean) => void) => {
                    const kennzahlen: any = (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort.tid]
                        || this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
                    const flags: any = kennzahlen.flags || {};

                    if (typeof callback === 'function') {
                        callback(!!flags.hasCO2);
                    }
                }}
                onStandortChange={(standort: number) => {
                    const basisRouting: any = RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE;
                    const basisTab: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
                    const tabRoutings: any[] = getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2);
                    const path: any = (tabRoutings.find((item: any) => item?.dataRow?.tid === standort) || {}).path || {};
                    this.props.onRoutingChange({ path: { ...RoutingIDs.ROUTE_CO2_FUSS_DETAILS, ...path } });
                }}
                renderClean
            />
        );
    }

    renderVeranstaltung(): JSX.Element {
        return <>
            <label>{i18n('Standort', 'sys')}</label>
            <input type='text' value={this.props.standortName} disabled />
        </>;
    }

    renderZuschlagEingabe(isPdf: boolean): any {
        if (isPdf) {
            return `${this.state.zuschlag} %`;
        }
        const helpIconZuschlag = (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ textAlign: 'center', display: 'inline-flex' }}
                styleProps={{ margin: '0 0 0 -26px' }}
                label={i18n('Datenauswertung - Hinweise', 'sys')}
                helpKey='datenauswertung_co2_gesamtergebnis'
                type='info'
                editBar
                useTheme
                useWhite
            />
        );
        if (this.props.standortTid > 0) {
            // Standorte / Lager
            return (
                <div style={{ marginTop: -4, marginBottom: -2, display: 'flex', justifyContent: 'space-between' }}>
                    {helpIconZuschlag}
                    <div className={formStyle.formCompact}>
                        <input
                            min={0}
                            max={10}
                            type='number'
                            value={this.state.zuschlag}
                            style={{ width: 40, padding: '0 2px' }}
                            onChange={(evt: any) => {
                                let zuschlag = evt.target.value;
                                if (zuschlag !== '') {
                                    zuschlag = Math.min(10, +zuschlag);
                                    zuschlag = Math.max(0, +zuschlag);
                                }
                                this.setState({ zuschlag }, () => {
                                    const handle = window.setTimeout(() => {
                                        if (this.zuschlagHandle === handle) {
                                            const zItem = this.getZuschlagItem();
                                            let zuschlagItem: any;
                                            if (!zItem) {
                                                zuschlagItem = {
                                                    tid: 0,
                                                    standort_tid: this.props.standortTid,
                                                    jahr: this.state.jahr
                                                };
                                            } else {
                                                zuschlagItem = {
                                                    tid: zItem.tid,
                                                    standort_tid: zItem.standort_tid_orig,
                                                    jahr: this.state.jahr
                                                };
                                            }
                                            zuschlagItem.zuschlag = zuschlag;
                                            this.zuschlagSaveItem = zuschlagItem;
                                            this.dataService.saveData(
                                                IDs.ENT_CO2_SICHERHEITSZUSCHLAG, this.zuschlagSaveItem, null, false,
                                                () => this.triggerService.fire('reload', IDs.ENT_CO2_SICHERHEITSZUSCHLAG),
                                                IDs.MOD_ETOOL
                                            );
                                        }
                                    }, 500);
                                    this.zuschlagHandle = handle;
                                });
                            }}
                        /> %
                    </div>
                </div>
            );
        } else {
            // Gesamt
            return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {this.renderZuschlagWgt(helpIconZuschlag)}
            </div>;
        }
    }

    renderZuschlagWgt(help: JSX.Element): JSX.Element {
        const { jahr } = this.state
        const zuschlagRows = this.props.data[IDs.ENT_CO2_SICHERHEITSZUSCHLAG] || [];
        const kennStandorte = this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {};
        const standorte = Object.keys(kennStandorte).filter((s: string) => kennStandorte[s][jahr].co2_fussabdruck_total > 0);
        let sumEmi = 0;
        let sumEmiZus = 0;
        let zusWgt = 0;
        standorte.forEach((s: string) => {
            const emi = kennStandorte[s][jahr].co2_fussabdruck_total;
            const zusFnd = zuschlagRows.find((r: any) => r.standort_tid_orig === +s && r.jahr === jahr && r.zuschlag >= 0);
            if (zusFnd) {
                sumEmi += emi;
                sumEmiZus += emi * zusFnd.zuschlag;
            }
        });
        if (sumEmi !== 0) {
            zusWgt = sumEmiZus / sumEmi;
        }
        // console.log(sumEmiZus, sumEmi, zusWgt);
        return <>
            {help}
            <div>
                <div style={{ display: 'inline-block', padding: '0 2px' }}>
                    {fn2(zusWgt)}
                </div>
                %
            </div>
        </>;
    }

    setChartSelect(chartKey?: string): void {
        const values = this.getValues(chartKey);
        this.setState({ values, chartKey });
    }

    setChartSelect2(chartKeyT2?: string): void {
        const values = this.getValues(chartKeyT2);
        this.setState({ values, chartKeyT2 });
    }

    setKategorieRow(data: any[], rows: any[], value: number, sum: number) {
        if (
            !(data || []).length || !(rows || []).length || value === 0 || !sum
            // || typeof (rows[rows.length - data.length - 1] || [])[3] === 'undefined'
            // || typeof (rows[rows.length - data.length - 1] || [])[4] === 'undefined'
            || (rows[rows.length - data.length - 1] || [])[3] !== ''
            || (rows[rows.length - data.length - 1] || [])[4] !== ''
        ) {
            return;
        }
        rows[rows.length - data.length - 1][3] = fn2(value);
        rows[rows.length - data.length - 1][4] = `${fn2(100 / sum * value)} %`;
    }

    sortKategorieRows(data: any[], rows: any[], classes: string[]) {
        const sortOption: any = this.columnsSortOptions[this.state.columnsSortIndex] || {};

        if ((data || []).length < 2 || !(rows || []).length || !Object.keys(sortOption).length) {
            return;
        }
        const setMaxSum = (index: number, pos: number): void => {
            for (let i: number = pos; !!i; --i) {
                data[index - 1 - i].sum = data[index - 1].sum;
                data[index - i].group = 1;
            }
        };
        let lastKategorie: string = null;
        let pos: number;

        data.forEach((item: any, index: number) => {
            item.kategorie = item.kategorie || 'ZZZ';

            if (item.kategorie !== lastKategorie) {
                if (pos) {
                    setMaxSum(index, pos);
                }
                item.group = 0;
                item.pos = pos = 0;
            } else {
                item.pos = ++pos;

                if ((index + 1) === data.length) {
                    setMaxSum(index + 1, pos);
                }
            }
            lastKategorie = item.kategorie;
        });
        data.sort((a: any, b: any) => sortOption.sort(a, b));
        rows.splice(rows.length - data.length, data.length, ...data.map((item: any) => item._row || []));
        classes.splice(rows.length - data.length, data.length, ...data.map((item: any) => item._classes || []));
    }

    sortRows(data: any[], rows: any[], classes?: string[]) {
        const sortOption: any = this.columnsSortOptions[this.state.columnsSortIndex] || {};

        if (!(data || []).length || !(rows || []).length || !Object.keys(sortOption).length) {
            return;
        }
        data.sort((a: any, b: any) => sortOption.sort(a, b));
        rows.splice(rows.length - data.length, data.length, ...data.map((item: any) => item._row || []));

        if ((classes || []).length) {
            classes.splice(rows.length - data.length, data.length, ...data.map((item: any) => item._classes || []));
        }
    }

    getTransportmittelMobilitaet(structKey: string, transportmittel: string): string {
        const entityName = `co2_scope3_${structKey}`;
        const struct = this.structureService.getStructureByKey(IDs.MOD_ETOOL, entityName);
        if (struct && Array.isArray(struct.ATTS)) {
            const attr = struct.ATTS.find((a: any) => a.KEY === 'transportmittel_mobilitaet');
            if (attr && Array.isArray(attr.OPTS)) {
                const opt = attr.OPTS.find((o: any) => o.VALUE === transportmittel);
                if (opt) {
                    return opt.TITEL;
                }
            }
        }
        return '';
    }

    getKzConcat(struct: any, kzRows: any[]): any[] {
        let kzConcat;
        if (struct && kzRows && kzRows.length > 0) {
            // getCO2Scope3StructureVorgelagert / getCO2Scope3StructureNachgelagert
            if (['transport_vorgelagert', 'reisen', 'pendeln', 'transport_nachgelagert'].indexOf(struct.key) !== -1) {
                const map: any = {};
                kzRows.forEach((r: any, idx: number) => {
                    const key = r.teilstrecken_orig === 1 || r.faktor_einheit === 'gemischt' || (r.tid + '').startsWith('kampagne_') ? `idx_${idx}`
                        : r.transportmittel === 'uebernachtung' || r.transportmittel_mobilitaet === 'uebernachtung' ? [r.unterkunft || 'X', r.faktor || 'X', r.faktor_einheit || 'X'].join()
                            : r.modus === 'distance_based' ? [r.transportmittel_mobilitaet || r.transportmittel || 'X', r.einheit || 'X', r.faktor || 'X', r.faktor_einheit || 'X'].join()
                                : r.modus === 'fuel_based' ? [r.energietraeger_tid || 'X', r.einheit || 'X', r.faktor || 'X', r.faktor_einheit || 'X'].join()
                                    : r.modus === 'spend_based' ? [r.transportmittel || 'X', r.einheit || 'X', r.faktor || 'X', r.faktor_einheit || 'X'].join()
                                        : `idx_${idx}`;
                    if (key) {
                        if (!map[key]) {
                            map[key] = { ...r };
                        } else {
                            map[key].menge += r.menge;
                            map[key].value += r.value;
                        }
                    }
                });
                kzConcat = Object.keys(map).map((k: string) => map[k]);
                // console.log(kzConcat, kzRows);
            }
        }
        return kzConcat;
    }

    renderKennzahlenInfo(dataText: string, jahr: number, key: string, field: string): JSX.Element | string {
        // console.log('renderKennzahlenInfo', dataText, key);
        return this.showKennzahlenInfo
            ? <KennzahlenInfo
                data={this.props.data}
                data-text={dataText}
                id={`${key}_${field}_${jahr}`}
                key={`${key}_${field}_${jahr}`}
                keyValue={`${key}_${field}`}
                jahr={jahr}
                standort={this.props.standortTid || 'ALL'}
            />
            : dataText;
    }
}
